<app-dashboard-navbar *ngIf="!isVendor" [isLogo]="isLogo"></app-dashboard-navbar>
<ng-container [ngTemplateOutlet]="dashboardTemplate" [ngTemplateOutletContext]="{$implicit:tempCode}"></ng-container>

<div style="display: none;padding-top: 150px; ">
    <div style="text-align:center; ">
        <h1>
            Capture Image Demo
        </h1>

        <div class="row">
            <div class="col-1-of-2">
                <webcam [height]="250" [width]="250" [trigger]="triggerObservable" (imageCapture)="handleImage($event)"
                    *ngIf="showWebcam" [allowCameraSwitch]="allowCameraSwitch" [switchCamera]="nextWebcamObservable"
                    [videoOptions]="videoOptions" [imageQuality]="1" (cameraSwitched)="cameraWasSwitched($event)"
                    (initError)="handleInitError($event)" style="border: black;
                border-style: solid;
                border-width: thick"></webcam>
                <br />
                <button class="actionBtn" (click)="triggerSnapshot();">Take A Snapshot</button>
                <!-- <button class="actionBtn" (click)="toggleWebcam();">Toggle Webcam</button> -->
                <br />
                <!-- <button class="actionBtn" (click)="showNextWebcam(true);" [disabled]="!multipleWebcamsAvailable">Next Webcam</button>
        <input id="cameraSwitchCheckbox" type="checkbox" [(ngModel)]="allowCameraSwitch"><label for="cameraSwitchCheckbox">Allow Camera Switch</label> -->
                <br />
                <!-- DeviceId: <input id="deviceId" type="text" [(ngModel)]="deviceId" style="width: 500px">
        <button (click)="showNextWebcam(deviceId);">Activate</button>
        <br/>
        Preferred facing mode:
        <input type="radio" value="user" name="facingMode" [(ngModel)]="facingMode"> User
        <input type="radio" value="environment" name="facingMode" [(ngModel)]="facingMode"> Environment
        <input type="radio" value="" name="facingMode" [(ngModel)]="facingMode"> No preference -->
            </div>
            <div class="snapshot col-1-of-2" *ngIf="webcamImage">
                <h2>Nice one!</h2>
                <img [src]="webcamImage.imageAsDataUrl" />
            </div>
        </div>
    </div>





    <h4 *ngIf="errors.length > 0">Messages:</h4>
    <ul *ngFor="let error of errors">
        <li>{{error | json}}</li>
    </ul>

</div>

<div class="sample-container" style="display: none;">

    <div class="imgcapture">
        <div class="capturehead">
            <h4>Image Capture</h4>
            <div class="capbtns">
                <button title="Capture">
                    <svg class="">
                        <use xlink:href="./assets/dashboard-sample/img/common-sprite.svg#newcamera"></use>
                    </svg>
                </button>

                <button title="Upload">
                    <svg class="">
                        <use xlink:href="./assets/dashboard-sample/img/common-sprite.svg#upload"></use>
                    </svg>
                </button>

                <button title="Clear">
                    <svg class="">
                        <use xlink:href="./assets/dashboard-sample/img/common-sprite.svg#clear"></use>
                    </svg>
                </button>

                <button title="View">
                    <svg class="">
                        <use xlink:href="./assets/dashboard-sample/img/common-sprite.svg#eyeview"></use>
                    </svg>
                </button>
            </div>
        </div>
        <div class="capturecontent">

        </div>
    </div>

</div>

<ng-template #dashboardTemplate let-tempCode>
    <ng-container [ngSwitch]="tempCode">
        <div class="dashBordContent" *ngSwitchCase="'T1'">
            <div class="contentsection">
                <div class="topColumns">
                    <div class="userdetails">
                        <app-profile-details></app-profile-details>
                    </div>
                    <div class="columnChart">
                        <div class="coltitles">
                            <h4>{{dashboardTemplateForm.value.chartBlock1Title}}
                                <!-- <Small *ngIf="this.graphData">February total:
                                <strong>{{this.graphData[0].gstibo_chart1_count}}</strong></Small> -->
                            </h4>
                            <select class="form-control" style="width:40%;" *ngIf="projectListData.length>0"
                                (change)="onPrjEmplist_change($event)">
                                <option value='{{itm.gstibo_project_id}}' *ngFor="let itm of (projectListData)"
                                    [selected]="(itm.gstibo_project_id == '0')">{{itm.gstibo_project_name}}
                                </option>
                            </select>
                            <select name="" id="">
                                <option value="">Week 1</option>
                            </select>
                        </div>
                        <div id="projectChart" style="height:25rem; width: 100%;">
                            <app-chart-controls [chartForm]="chartForm1"></app-chart-controls>
                            <!-- <img src="./assets/dashboard-sample/img/chart4.jpg" alt=""> -->
                        </div>
                    </div>

                    <div class="donutChart">
                        <div class="coltitles">
                            <h4>{{dashboardTemplateForm.value.chartBlock2Title}}
                                <small *ngIf="this.graphData">Total Employees:
                                    <strong>{{totalEmpCnt}}</strong></small>
                                <!-- <small>Total Employees: <strong>183</strong></small> -->
                            </h4>
                        </div>
                        <div id="employeechart" style="height: 25rem; width: 100%;">
                            <app-chart-controls [chartForm]="chartForm2"></app-chart-controls>
                            <!-- <img src="./assets/dashboard-sample/img/chart_2.jpg" alt=""> -->
                        </div>
                    </div>
                </div>

                <div class="bottomColumns">

                    <app-dashboard-colored-column></app-dashboard-colored-column>

                    <div class="dashboardfooter">
                        <div class="piechartcolumn">
                            <div class="coltitles">
                                <h4>{{dashboardTemplateForm.value.chartBlock3Title}}
                                    <!-- <Small *ngIf="this.graphData">February total:
                                    <strong>{{ this.graphData[0].gstibo_chart3_count}}</strong></Small> -->
                                </h4>
                                <select class="form-control" style="width:40%;" *ngIf="projectListData.length>0"
                                    (change)="onLeaveEmplist_change($event)">
                                    <option value='{{itm.gstibo_project_id}}' *ngFor="let itm of (projectListData)"
                                        [selected]="(itm.gstibo_project_id == '0')">{{itm.gstibo_project_name}}
                                    </option>
                                </select>
                            </div>
                            <div id="leavechart" style="width:auto; height: 20rem;">
                                <app-chart-controls [chartForm]="chartForm3"></app-chart-controls>
                                <!-- <img src="./assets/dashboard-sample/img/chart_3.jpg" alt=""> -->
                            </div>
                        </div>

                        <app-bulletin></app-bulletin>
                    </div>

                </div>
            </div>
            <div class="boardside">
                <!-- <app-manage-presence></app-manage-presence> -->

                <div class="meetingevent">
                    <div class="coltitles">

                        <h4 style="margin-bottom: 0;"> Schedule Meeting </h4> <button
                            class="schedulemeeting display-none" (click)="redirecttomeeting();">
                            <svg>
                                <use xlink:href="./assets/dashboard-sample/img/sprite.svg#meetings"></use>
                            </svg>
                        </button>
                    </div>
                    <div *ngIf="MeetingList.length>0">
                        <h5> Schedule...</h5>
                        <div class="divmeetinglist">
                            <ul class="meetinglist">
                                <li *ngFor="let item of MeetingList">
                                    <span>
                                        <h6>Schedule By: {{item.Hostby}}</h6>


                                        {{item.Topic}} - {{item.StartTime}}
                                    </span><a href="{{item.JoinUrl}}" target="_blank"> Click here</a>

                                </li>
                            </ul>

                        </div>
                    </div>
                </div>
                <app-todays-event></app-todays-event>

                <div class="absents">
                    <h3>{{dashboardTemplateForm.value.SB1Title}}</h3>
                    <app-absent-employee-list></app-absent-employee-list>
                </div>

                <div class="listodo">
                    <app-dashboard-to-do-list></app-dashboard-to-do-list>

                </div>
            </div>
        </div>
        <div class="dashBordContent" *ngSwitchCase="'T2'">
            <div class="contentsection">
                <div class="crmgrid">
                    <div class="boxes columnChart">
                        <div class="coltitles">
                            <h4>{{dashboardTemplateForm.value.crmCB1Title}}</h4>
                        </div>
                        <ng-container *ngFor="let dp of dealsProgress;">
                            <div class="orangebars">
                                <p>{{dp.value}} {{dp.item}} <span>{{dp.value}}</span></p>
                                <div class="thinprogress">
                                    <div class="bars" [style.width]="dp.perc"></div>
                                </div>
                            </div>
                        </ng-container>
                    </div>

                    <div class="boxes">
                        <div class="coltitles">
                            <h4>{{dashboardTemplateForm.value.crmCB2Title}}</h4>
                        </div>
                        <div id="columnchart_values" style="height: 23rem; width: 100%;">
                            <app-chart-controls [chartForm]="chartForm2"></app-chart-controls>
                        </div>
                    </div>

                    <div class=" boxes">
                        <div class="coltitles">
                            <h4>{{dashboardTemplateForm.value.crmCB3Title}}</h4>
                        </div>
                        <table class="dashboard_table">
                            <thead>
                                <tr>
                                    <th scope="col"> &nbsp; </th>
                                    <th scope="col">Deals Won</th>
                                    <th scope="col">Deals Open</th>
                                    <th scope="col">Deals Lost</th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngFor="let dp of dealsPivote;">
                                    <tr>
                                        <th scope="row">{{dp.gstibo_item}}</th>
                                        <td>{{dp.gstibo_won_value}} <span
                                                [class]="dp.gstibo_won_color">{{dp.gstibo_won_per}}</span></td>
                                        <td>{{dp.gstibo_open_value}} <span
                                                [class]="dp.gstibo_open_color">{{dp.gstibo_open_per}}</span></td>
                                        <td>{{dp.gstibo_lost_value}} <span
                                                [class]="dp.gstibo_lost_color">{{dp.gstibo_lost_per}}</span></td>
                                    </tr>
                                </ng-container>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="middleBoxes">
                    <div *ngIf="leadTiles[0]" class="coloredColumns violetBg">
                        <div class="divem">
                            <p>{{leadTiles[0].gstibo_item}}</p>
                            <h4>{{leadTiles[0].gstibo_value1}}</h4>
                            <h2>{{leadTiles[0].gstibo_value2}}</h2>
                        </div>
                        <div class="amounts">
                            <h5>{{leadTiles[0].gstibo_value3}}</h5>
                            <h5>${{leadTiles[0].gstibo_value4}}</h5>
                        </div>
                    </div>
                    <div *ngIf="leadTiles[1]" class="coloredColumns orangeBg">
                        <div class="divem">
                            <p>{{leadTiles[1].gstibo_item}}</p>
                            <h4>{{leadTiles[1].gstibo_value1}}</h4>
                            <h2>{{leadTiles[1].gstibo_value2}}</h2>
                        </div>
                        <div class="amounts">
                            <h5>{{leadTiles[1].gstibo_value3}}</h5>
                            <h5>${{leadTiles[1].gstibo_value4}}</h5>
                        </div>
                    </div>
                    <div *ngIf="leadTiles[2]" class="coloredColumns greenBg">
                        <div class="divem">
                            <p>{{leadTiles[2].gstibo_item}}</p>
                            <h4>{{leadTiles[2].gstibo_value1}}</h4>
                            <h2>{{leadTiles[2].gstibo_value2}}</h2>
                        </div>
                        <div class="amounts">
                            <h5>{{leadTiles[2].gstibo_value3}}</h5>
                            <h5>${{leadTiles[2].gstibo_value4}}</h5>
                        </div>
                    </div>
                </div>

                <div class="crmgrid">
                    <div class="boxes columnChart">
                        <div class="coltitles">
                            <h4>{{dashboardTemplateForm.value.crmCB4Title}}</h4>

                        </div>
                        <div *ngIf="leadConversation[0]" class="coloredbar">
                            <div class="thik_progress red">
                                {{leadConversation[0].gstibo_created_value}}
                            </div>
                            <p>{{leadConversation[0].gstibo_created_per}}%</p>
                            <div class="thik_progress orange">
                                {{leadConversation[0].gstibo_converted_value}}
                            </div>
                            <p>{{leadConversation[0].gstibo_converted_per}}%</p>
                            <div class="thik_progress green">
                                {{leadConversation[0].gstibo_won_value}}
                            </div>
                            <p>{{leadConversation[0].gstibo_won_per}}%</p>
                            <div class="thik_progress blue">
                                {{leadConversation[0].gstibo_lost_value}}
                            </div>
                            <p>{{leadConversation[0].gstibo_lost_per}}%</p>
                        </div>
                        <div class="colorbullet">
                            <p><span class="red"></span>Leads Created</p>
                            <p><span class="orange"></span>Leads Converted</p>
                            <p><span class="green"></span>Leads Won</p>
                            <p><span class="blue"></span>Leads Lost</p>
                        </div>
                    </div>

                    <div class="boxes donutChart">
                        <div class="coltitles">
                            <h4>{{dashboardTemplateForm.value.crmCB5Title}}</h4>
                        </div>
                        <div style="width: 100%; height: 23rem; display: flex; justify-content: center;">
                            <app-chart-controls [chartForm]="chartForm5"></app-chart-controls>
                        </div>
                    </div>

                    <div class="boxes">
                        <div class="coltitles">
                            <h4>{{dashboardTemplateForm.value.crmCB6Title}}</h4>
                        </div>
                        <div id="budget_chart" style="width: 100%; height: 23rem;">
                            <app-chart-controls [chartForm]="chartForm6"></app-chart-controls>
                        </div>
                    </div>
                </div>

            </div>
            <div class="boardside dealslist">
                <h3>{{dashboardTemplateForm.value.SB1Title}}</h3>
                <ng-container *ngFor="let dl of top5Deals;">
                    <div class="dealings">
                        <div class="titls">
                            <div class="number">{{dl.gstibo_id}}</div>
                            <h4>{{dl.gstibo_name}}
                                <span>${{dl.gstibo_value}}</span>
                            </h4>
                        </div>
                        <p>Salse Rep: {{dl.gstibo_salesrep}}</p>
                        <p>Sales Cycle Length: {{dl.gstibo_days}} days</p>
                    </div>
                </ng-container>
            </div>
        </div>
        <div class="recruit-board" *ngSwitchCase="'T3'">
            <div class="boardcontent">
                <div class="boardcolumns">
                    <div class="recruit-box">
                        <div class="coltitles">
                            <h4>
                                {{dashboardTemplateForm.value.chartBlock1Title}}
                                <!-- Open Requisition By Dept. -->
                                <!-- <Small>February total:  <strong>175</strong></Small> -->
                            </h4>
                        </div>
                        <div style="width: 100%;height: 25rem;">
                            <app-chart-controls [chartForm]="chartForm1"></app-chart-controls>
                        </div>
                    </div>
                    <div class="recruit-box">
                        <div class="coltitles">

                            <h4>
                                {{dashboardTemplateForm.value.chartBlock2Title}}
                            </h4>
                        </div>
                        <div class="donut"
                            style="--first: .18; --second: .16; --third: .17; --fourth: .16; --fifth: .17; --sixth: .17;">
                            <div class="donut__slice donut__slice__first">
                                <span *ngIf="roundChartEffHiring[0]"> {{roundChartEffHiring[0].gstibo_value}} </span>
                            </div>
                            <div class="donut__slice donut__slice__second">
                                <span *ngIf="roundChartEffHiring[1]"> {{roundChartEffHiring[1].gstibo_value}} </span>
                            </div>
                            <div class="donut__slice donut__slice__third">
                                <span *ngIf="roundChartEffHiring[2]"> {{roundChartEffHiring[2].gstibo_value}} </span>
                            </div>
                            <div class="donut__slice donut__slice__fourth">
                                <span *ngIf="roundChartEffHiring[3]"> {{roundChartEffHiring[3].gstibo_value}} </span>
                            </div>
                            <div class="donut__slice donut__slice__fifth">
                                <span *ngIf="roundChartEffHiring[4]"> {{roundChartEffHiring[4].gstibo_value}} </span>
                            </div>
                            <div class="donut__slice donut__slice__sixth">
                                <span *ngIf="roundChartEffHiring[5]"> {{roundChartEffHiring[5].gstibo_value}} </span>
                            </div>
                            <div class="donut__label">
                                <div class="donut__label__heading">
                                    {{totalEHValue}}
                                </div>
                            </div>
                        </div>
                        <div class="donut-colors">
                            <p *ngIf="roundChartEffHiring[0]"><span class="violetBg"></span>
                                {{roundChartEffHiring[0].gstibo_Item}} </p>
                            <p *ngIf="roundChartEffHiring[1]"><span class="newBlue"></span>
                                {{roundChartEffHiring[1].gstibo_Item}} </p>
                            <p *ngIf="roundChartEffHiring[2]"><span
                                    class="newRed"></span>{{roundChartEffHiring[2].gstibo_Item}}
                            </p>
                            <p *ngIf="roundChartEffHiring[3]"><span class="greenBg"></span>
                                {{roundChartEffHiring[3].gstibo_Item}} </p>
                            <p *ngIf="roundChartEffHiring[4]"><span class="orangeBg"></span>
                                {{roundChartEffHiring[4].gstibo_Item}} </p>
                            <p *ngIf="roundChartEffHiring[5]"><span class="darkPink"></span>
                                {{roundChartEffHiring[5].gstibo_Item}} </p>
                        </div>
                    </div>
                    <div class="recruit-box ">
                        <div class="coltitles">
                            <h4>
                                {{dashboardTemplateForm.value.chartBlock3Title}}

                            </h4>
                        </div>
                        <div class="gridbox">
                            <div class="funnelouter">
                                <div *ngIf="recruitmentFunnel[0]" class="funnelbar">
                                    <p>{{recruitmentFunnel[0].gstibo_Item}}</p>
                                    <span style="flex: 0 0 90%;">{{recruitmentFunnel[0].gstibo_value}}%</span>
                                </div>
                                <div *ngIf="recruitmentFunnel[1]" class="funnelbar">
                                    <p>{{recruitmentFunnel[1].gstibo_Item}}</p>
                                    <span style="flex: 0 0 70%;">{{recruitmentFunnel[1].gstibo_value}}%</span>
                                </div>
                                <div *ngIf="recruitmentFunnel[2]" class="funnelbar">
                                    <p>{{recruitmentFunnel[2].gstibo_Item}}</p>
                                    <span style="flex: 0 0 55%;">{{recruitmentFunnel[2].gstibo_value}}%</span>
                                </div>
                                <div *ngIf="recruitmentFunnel[3]" class="funnelbar">
                                    <p>{{recruitmentFunnel[3].gstibo_Item}}</p>
                                    <span style="flex: 0 0 45%;">{{recruitmentFunnel[3].gstibo_value}}%</span>
                                </div>
                                <div *ngIf="recruitmentFunnel[4]" class="funnelbar">
                                    <p>{{recruitmentFunnel[4].gstibo_Item}}</p>
                                    <span style="flex: 0 0 35%;">{{recruitmentFunnel[4].gstibo_value}}%</span>
                                </div>
                                <div *ngIf="recruitmentFunnel[5]" class="funnelbar">
                                    <p>{{recruitmentFunnel[5].gstibo_Item}}</p>
                                    <span style="flex: 0 0 28%;">{{recruitmentFunnel[5].gstibo_value}}%</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="recruit-box">
                        <div class="coltitles">
                            <h4>
                                {{dashboardTemplateForm.value.chartBlock5Title}}

                            </h4>
                        </div>
                        <div style="width: 100%;height: 25rem;">
                            <app-chart-controls [chartForm]="chartForm5"></app-chart-controls>
                        </div>
                    </div>
                    <div class="recruit-box largebox">
                        <div class="coltitles">
                            <h4>
                                {{dashboardTemplateForm.value.chartBlock6Title}}

                            </h4>
                        </div>
                        <div style="width: 100%;height: 25rem;">
                            <app-chart-controls [chartForm]="chartForm6"></app-chart-controls>
                        </div>
                    </div>

                </div>
            </div>
            <div class="boardSidebar">
                <div class="recruit-box">
                    <div class="coltitles">
                        <h4>
                            {{dashboardTemplateForm.value.chartBlock4Title}}

                        </h4>
                    </div>
                    <div style="width: 100%;height: 25rem;">
                        <app-chart-controls [chartForm]="chartForm4"></app-chart-controls>
                    </div>
                </div>
                <div class="recruit-box">
                    <div class="coltitles">
                        <h4>
                            {{dashboardTemplateForm.value.chartBlock7Title}}

                        </h4>
                    </div>
                    <div class="declines">
                        <div class="declines-titles">
                            # of Apps
                        </div>
                        <div class="declines-titles">
                            % of Apps
                        </div>
                    </div>
                    <ng-container *ngFor="let od of offerDecline;">
                        <div class="declines">
                            <div class="declines-names">
                                <span>{{od.gstibo_item}}</span>
                                <span>{{od.gstibo_value}}</span>
                            </div>
                            <div class="declines-bars">
                                <div class="greenbar" [style.width.%]="od.gstibo_per"></div>
                                <div class="barpercent">{{od.gstibo_per}}%</div>
                            </div>
                        </div>
                    </ng-container>

                </div>
            </div>
        </div>
        <div class="dashBordContent" *ngSwitchCase="'T4'">
            <div class="contentsection customer">
                <div class="topColumns">

                    <div class="userdetails">
                        <app-profile-details></app-profile-details>
                        <div class="defaultproject">
                            <select class="form-control" *ngIf="projectList.length>0"
                                (change)="onGroupEmplist_change($event)">
                                <option value='{{itm.gstibo_project_id}}' *ngFor="let itm of (projectList)"
                                    [selected]="(itm.gstibo_project_id == defaultProjectId  ? true : false)">
                                    {{itm.gstibo_project_name}}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="columnChart" style="padding-top:4rem;">
                        <div class="coltitles">
                            <h4>
                                <!-- Project Hours Tracked -->
                                {{dashboardTemplateForm.value.chartBlock1Title}}
                                <!-- <Small *ngIf="this.graphData">February total:
                                <strong>{{this.graphData[0].gstibo_chart1_count}}</strong></Small> -->
                            </h4>

                            <!-- <select name="" id="">
                            <option value="">Week 1</option>
                        </select> -->
                        </div>
                        <div id="projectChart" style="height:25rem; width: 100%;">
                            <app-chart-controls [chartForm]="chartForm1"></app-chart-controls>
                            <!-- <img src="./assets/dashboard-sample/img/chart4.jpg" alt=""> -->
                        </div>
                    </div>

                    <div class="columnChart" style="padding-top:4rem;">
                        <div class="coltitles">
                            <h4>{{dashboardTemplateForm.value.chartBlock2Title}}


                            </h4>
                        </div>
                        <div id="projectChart" style="height: 25rem; width: 100%;">
                            <app-chart-controls *ngIf="chartForm2ExpnseLength > 0" [chartForm]="chartForm2">
                            </app-chart-controls>
                            <div *ngIf="chartForm2ExpnseLength == 0" style="padding-top: 25%">
                                <span *ngIf="chartForm2ExpnseLength == 0" style="padding-left: 25% !important;">No Data
                                    To
                                    Preview</span>

                            </div>

                        </div>
                    </div>
                </div>

                <!-- <div class="bottomColumns">
    
                <app-dashboard-colored-column></app-dashboard-colored-column>
    
                <div class="dashboardfooter">
                    <div class="piechartcolumn">
                        <div class="coltitles">
                            <h4>{{dashboardTemplateForm.value.chartBlock3Title}}
                             
                            </h4>
                        </div>
                        <div id="leavechart" style="width:auto; height: 20rem;">
                            <app-chart-controls [chartForm]="chartForm3"></app-chart-controls>
                           
                        </div>
                    </div>
    
                    <app-bulletin></app-bulletin>
                </div>
    
            </div> -->
                <div class="dashgrids">
                    <div class="progrids">

                        <!-- <h4>Timesheet Details
                                         <Small>Project name</Small>
                                  </h4> -->
                        <app-dashboard-timesheet-project-hours></app-dashboard-timesheet-project-hours>
                        <!-- <select name="" id="">
                                         <option selected>Select Project</option>
                                         <option value="">Project name</option>
                                  </select> -->

                    </div>
                    <!-- <table class="common_table">
                           <tr>
                            <th style="width: 6rem;">Emp No</th>
                            <th style="width: 55%;">Emp Name</th>
                            <th>Hours
                                  <small>Dec</small>
                           </th>
                            <th>Hours 
                                  <small>To-date</small> 
                           </th>
                            </tr>
                            <tr>
                                   <td>303</td>
                                   <td>Susan Mary Mathew</td>
                                   <td>120 Hrs</td>
                                   <td>40 Hrs</td>
                            </tr>
                            <tr>
                                  <td>303</td>
                                  <td>Susan Mary Mathew</td>
                                  <td>120 Hrs</td>
                                  <td>40 Hrs</td>
                           </tr>
                           <tr>
                                  <td>303</td>
                                  <td>Susan Mary Mathew</td>
                                  <td>120 Hrs</td>
                                  <td>40 Hrs</td>
                           </tr>
                           <tr>
                                  <td>303</td>
                                  <td>Susan Mary Mathew</td>
                                  <td>120 Hrs</td>
                                  <td>40 Hrs</td>
                           </tr>
                           <tr>
                                  <td>303</td>
                                  <td>Susan Mary Mathew</td>
                                  <td>120 Hrs</td>
                                  <td>40 Hrs</td>
                           </tr>
                            </table> -->

                    <div class="progrids">
                        <div class="coltitles">
                            <h4>{{dashboardTemplateForm.value.chartBlock3Title}}
                                <!-- <small>Any Description</small> -->
                            </h4>
                        </div>
                        <div id="ProExpense" style="height: 25rem; width: 100%;">
                            <app-chart-controls [chartForm]="chartForm3"></app-chart-controls>
                        </div>
                        <!-- <div id="ProExpense" style="width:auto; height: 20rem;">
                        </div> -->
                    </div>
                </div>

            </div>
            <div class="boardside customerside" style="padding-top: 4rem;">
                <!-- <app-manage-presence></app-manage-presence>
            <app-todays-event></app-todays-event> -->
                <div class="absents">
                    <h3>{{dashboardTemplateForm.value.SB1Title}}</h3>
                    <app-absent-employee-list></app-absent-employee-list>
                </div>
                <div class="listodo">
                    <!--customer dashboard todo-->
                    <app-dashboard-to-do-list></app-dashboard-to-do-list>

                </div>

            </div>
        </div>

        <div class="dashBordContent" *ngSwitchCase="'T9'">
            <!-- Opportunity...... -->
            <div class="contentsection">
                <div class="topColumns">
                    <div class="userdetails">
                        <!-- <app-profile-details></app-profile-details> -->
                        <h2>Opportunity Overview</h2>
                    </div>
                    <div class="columnChart">
                        <div class="coltitles">
                            <h4>{{dashboardTemplateForm.value.chartBlock1Title}}
                                <!-- <Small *ngIf="this.graphData">February total:
                                <strong>{{this.graphData[0].gstibo_chart1_count}}</strong></Small> -->
                            </h4>
                            <select class="form-control" style="width:40%;" *ngIf="projectListData.length>0"
                                (change)="onPrjEmplist_change($event)">
                                <option value='{{itm.gstibo_project_id}}' *ngFor="let itm of (projectListData)"
                                    [selected]="(itm.gstibo_project_id == '0')">{{itm.gstibo_project_name}}
                                </option>
                            </select>
                            <select name="" id="">
                                <option value="">Week 1</option>
                            </select>
                        </div>
                        <div id="projectChart" style="height:25rem; width: 100%;">
                            <app-chart-controls [chartForm]="chartForm1"></app-chart-controls>
                            <!-- <img src="./assets/dashboard-sample/img/chart4.jpg" alt=""> -->
                        </div>
                    </div>

                    <div class="donutChart">
                        <div class="coltitles">
                            <h4>{{dashboardTemplateForm.value.chartBlock2Title}}
                                <!-- <small *ngIf="this.graphData">Total Employees:
                                <strong>{{totalEmpCnt}}</strong></small> -->
                                <!-- <small>Total Employees: <strong>183</strong></small> -->
                            </h4>
                        </div>
                        <div id="employeechart" style="height: 25rem; width: 100%;">
                            <app-chart-controls [chartForm]="chartForm2"></app-chart-controls>
                            <!-- <img src="./assets/dashboard-sample/img/chart_2.jpg" alt=""> -->
                        </div>
                    </div>
                </div>

                <div class="bottomColumns">

                    <app-dashboard-colored-column [customtile]="Opportunity"></app-dashboard-colored-column>

                    <div class="dashboardfooter">
                        <div class="piechartcolumn">
                            <div class="coltitles">
                                <h4>{{dashboardTemplateForm.value.chartBlock3Title}}
                                    <!-- <Small *ngIf="this.graphData">February total:
                                    <strong>{{ this.graphData[0].gstibo_chart3_count}}</strong></Small> -->
                                </h4>
                                <select class="form-control" style="width:40%;" *ngIf="projectListData.length>0"
                                    (change)="onLeaveEmplist_change($event)">
                                    <option value='{{itm.gstibo_project_id}}' *ngFor="let itm of (projectListData)"
                                        [selected]="(itm.gstibo_project_id == '0')">{{itm.gstibo_project_name}}
                                    </option>
                                </select>
                            </div>
                            <div id="leavechart" style="width:auto; height: 20rem;">
                                <app-chart-controls [chartForm]="chartForm3"></app-chart-controls>
                                <!-- <img src="./assets/dashboard-sample/img/chart_3.jpg" alt=""> -->
                            </div>
                        </div>

                        <app-bulletin></app-bulletin>
                    </div>

                </div>
            </div>
            <div class="boardside">

                <app-todays-event></app-todays-event>

                <div class="absents">
                    <h3>{{dashboardTemplateForm.value.SB1Title}}</h3>
                    <app-absent-employee-list></app-absent-employee-list>
                </div>

                <div class="listodo">
                    <app-dashboard-to-do-list></app-dashboard-to-do-list>

                </div>
            </div>
        </div>


        <div class="content-wraper" *ngSwitchCase="'T6'">

            <div class="empdashboard">
                <article>
                    <h2>
                        Dashboard Overview
                    </h2>
                    <app-dashboard-colored-columnnew></app-dashboard-colored-columnnew>

                    <div class="whiteblocks single">
                        <div class="newcolumtitlles">
                            <h4>
                                Bulletin
                            </h4>
                        </div>
                        <div style="overflow-y: auto; display: grid; height: 7.3rem; cursor:pointer;">
                            <app-bulletinnew></app-bulletinnew>
                        </div>
                    </div>
                    <div class="whiteblocks">
                        <div class="columbox">
                            <div class="newcolumtitlles">
                                <h4>
                                    {{dashboardTemplateForm.value.chartBlock1Title}}
                                </h4>
                                <div class="rightsideoptions">
                                    <select *ngIf="projectListData.length>0" (change)="onLeaveEmplist_change($event)">
                                        <option value='{{itm.gstibo_project_id}}' *ngFor="let itm of (projectListData)"
                                            [selected]="(itm.gstibo_project_id == '0')">{{itm.gstibo_project_name}}
                                        </option>
                                    </select>

                                    <select name="" id="">
                                        <option value="">
                                            Week 1
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div id="dealsourceChart" (click)="navigatePage()">
                                <app-chart-controls [chartForm]="chartForm1"></app-chart-controls>
                            </div>
                        </div>
                        <div class="columbox">
                            <div class="newcolumtitlles">
                                <h4>
                                    {{dashboardTemplateForm.value.chartBlock2Title}}
                                </h4>

                            </div>
                            <div id="employees" (click)="navigatePagetoExpenseReport()">
                                <app-chart-controls [chartForm]="chartForm2"></app-chart-controls>
                            </div>
                        </div>
                    </div>
                    <div class="whiteblocks" style="grid-template-columns: 1fr minmax(37rem, auto);">
                        <div class="columbox">
                            <div class="newcolumtitlles">
                                <h4>
                                    Time Off details <small>- Past 6 months</small>
                                </h4>
                                <div class="rightsideoptions">

                                    <select name="" id="">
                                        <option value="">
                                            All
                                        </option>
                                        <option value="">
                                            Current status
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div id="columnchart_material">
                                <app-chart-controls [chartForm]="chartForm3"></app-chart-controls>
                            </div>
                        </div>
                        <div class="columbox">
                            <app-absent-employee-listnew>
                            </app-absent-employee-listnew>
                            <!-- <app-absent-employee-listnew *ngIf="empasidebox[0].gstibo_chart_heading=='Absent Employee'">
                                    </app-absent-employee-listnew> -->

                        </div>
                    </div>
                </article>
                <aside style="grid-template-rows:6rem auto;">
                    <div class="asidebox">
                        <app-event-mailbox-buttons></app-event-mailbox-buttons>
                    </div>
                    <div class="asidebox">
                        <div class="newcolumtitlles">
                            <h4>
                                Schedule Meeting
                            </h4>
                            <div class="rightsideoptions">
                                <button title="Schedule Meeting" (click)="redirecttomeeting();">
                                    <svg>
                                        <use xlink:href="./assets/img/sprite.svg#zoom"></use>
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <div style="max-height: 27rem; overflow-y:auto" *ngIf="MeetingList.length>0">
                            <ul class="newmeetings">
                                <li *ngFor="let item of MeetingList">

                                    <p>
                                        <strong>Schedule By: {{item.Hostby}}</strong>
                                        {{item.Topic}} - {{item.StartTime}}
                                    </p>

                                    <a href="{{item.JoinUrl}}" target="_blank">
                                        Click here
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="asidebox">
                        <!-- <app-profile-detailsnew *ngIf="empasidebox[0].gstibo_chart_heading=='Profile Details'">
                    </app-profile-detailsnew> -->
                        <app-dashboard-to-do-listnew> </app-dashboard-to-do-listnew>

                    </div>
                    <!-- <div *ngFor="let item of empasidebox" class="asidebox">
                        
                     <app-profile-detailsnew *ngIf="item.gstibo_chart_heading=='Profile Details'"></app-profile-detailsnew> 
    
                    <app-absent-employee-listnew *ngIf="item.gstibo_chart_heading=='Absent Employee'">
                    </app-absent-employee-listnew>
                </div> -->
                </aside>
                <!-- <aside *ngIf="empasidebox.length==0">
                <div class="asidebox">
                    <app-profile-detailsnew></app-profile-detailsnew>
                
                    <app-absent-employee-listnew></app-absent-employee-listnew>
                </div>
            </aside> -->
            </div>

        </div>
        <div class="content-wraper" *ngSwitchCase="'T7'">

            <div class="crmdashboard">
                <article>
                    <h2>
                        CRM Dashboard
                    </h2>
                    <div class="heighlitcolmns">
                        <div *ngIf="leadTiles[0]" class="colmn">
                            <h4>
                                {{leadTiles[0].gstibo_item}}
                                <!-- Deals Started -->
                            </h4>
                            <div class="numbervalue">
                                <h3>{{leadTiles[0].gstibo_value1}} <span>{{leadTiles[0].gstibo_value2}}</span></h3>

                            </div>
                        </div>
                        <div *ngIf="leadTiles[1]" class="colmn">
                            <h4>
                                {{leadTiles[1].gstibo_item}}
                                <!-- Lost Deals -->
                            </h4>
                            <div class="numbervalue">
                                <h3>{{leadTiles[1].gstibo_value1}}<span>{{leadTiles[1].gstibo_value2}}</span></h3>

                            </div>
                        </div>
                        <div *ngIf="leadTiles[2]" class="colmn">
                            <h4>
                                {{leadTiles[2].gstibo_item}}
                                <!-- Won Deals -->
                            </h4>
                            <div class="numbervalue">
                                <h3>{{leadTiles[2].gstibo_value1}}<span>{{leadTiles[2].gstibo_value2}}</span></h3>

                            </div>
                        </div>
                    </div>

                    <div class="whiteblocks">
                        <div class="columbox">
                            <div class="newcolumtitlles">
                                <h4>
                                    {{dashboardTemplateForm.value.crmCB1Title}}
                                    <!-- Deals Progress by Count -->
                                </h4>

                            </div>
                            <!-- <div id="dealsourceChart" style="height: 23rem;"></div> -->
                            <div class="orangebars" *ngFor="let dp of dealsProgress;">
                                <p style="margin-bottom: 1px;">{{dp.value}} {{dp.item}} <span>{{dp.value}}</span></p>
                                <div class="thinprogress">
                                    <div [className]="dp.color" [style.width.%]="dp.perc"></div>

                                </div>
                            </div>

                        </div>
                        <div class="columbox">
                            <div class="newcolumtitlles">
                                <h4>
                                    {{dashboardTemplateForm.value.crmCB2Title}}
                                    <!-- Count of status by source -->
                                </h4>

                            </div>
                            <div id="sourcestatus" style="height: 15rem;">
                                <app-chart-controls [chartForm]="chartForm2"></app-chart-controls>
                            </div>
                        </div>
                    </div>
                    <div class="whiteblocks">

                        <div class="columbox">
                            <div class="newcolumtitlles">
                                <h4>
                                    {{dashboardTemplateForm.value.crmCB4Title}}
                                    <!-- Lead Conversation analytics -->
                                </h4>

                            </div>
                            <div *ngIf="leadConversation[0]" class="coloredbar">
                                <div class="thik_progress red">

                                </div>
                                <p style="margin-bottom: 0">{{leadConversation[0].gstibo_created_per}}%</p>
                                <div class="thik_progress orange">

                                </div>
                                <p style="margin-bottom: 0">{{leadConversation[0].gstibo_converted_per}}%</p>
                                <div class="thik_progress green">

                                </div>
                                <p style="margin-bottom: 0">{{leadConversation[0].gstibo_won_per}}%</p>
                                <div class="thik_progress blue">

                                </div>
                                <p style="margin-bottom: 0">{{leadConversation[0].gstibo_lost_per}}%</p>
                            </div>
                            <div class="colorbullet">
                                <p><span class="red"></span>Created</p>
                                <p><span class="orange"></span>Converted</p>
                                <p><span class="green"></span>Won</p>
                                <p><span class="blue"></span>Lost</p>
                            </div>
                        </div>
                        <div class="columbox">
                            <div class="newcolumtitlles">
                                <h4>
                                    {{dashboardTemplateForm.value.crmCB6Title}}
                                    <!-- Total Value converted -->
                                </h4>

                            </div>

                            <div id="curve_chart" style="height: 15rem;">

                                <app-chart-controls [chartForm]="chartForm6"></app-chart-controls>
                            </div>
                        </div>

                    </div>
                    <div class="whiteblocks">

                        <div class="columbox">
                            <div class="newcolumtitlles">
                                <h4>
                                    {{dashboardTemplateForm.value.crmCB3Title}}
                                    <!-- Lead Conversation analytics -->
                                </h4>

                            </div>
                            <table class="chartable">
                                <thead>
                                    <tr>
                                        <th scope="col"></th>
                                        <th scope="col">Deals won</th>
                                        <th scope="col">Deals open</th>
                                        <th scope="col">Deals lost</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr *ngFor="let dp of dealsPivote;">
                                        <th scope="row" [className]="dp.colorclass">{{dp.gstibo_item}}</th>
                                        <td>{{dp.gstibo_won_value}} <span
                                                [class]="dp.gstibo_won_color">{{dp.gstibo_won_per}}</span></td>
                                        <td>{{dp.gstibo_open_value}} <span
                                                [class]="dp.gstibo_open_color">{{dp.gstibo_open_per}}</span></td>
                                        <td>{{dp.gstibo_lost_value}} <span
                                                [class]="dp.gstibo_lost_color">{{dp.gstibo_lost_per}}</span></td>
                                    </tr>


                                </tbody>
                            </table>
                        </div>
                        <div class="columbox">
                            <div class="newcolumtitlles">
                                <h4>
                                    {{dashboardTemplateForm.value.crmCB5Title}}
                                    <!-- Goal VS Actual -->
                                </h4>

                            </div>
                            <div style="display:grid; justify-content:center;">
                                <div id="actulagoal" style="height: 14rem; ">
                                    <app-chart-controls [chartForm]="chartForm5"></app-chart-controls>
                                </div>
                            </div>
                        </div>
                    </div>
                </article>
                <aside>

                    <div class="asidebox">
                        <div class="asidetitle">
                            <h4>
                                {{dashboardTemplateForm.value.SB1Title}}
                                <!-- Notifications -->
                            </h4>

                        </div>
                        <ul class="absentemps">
                            <li *ngFor="let dl of top5Deals;">
                                <span>
                                    {{dl.gstibo_id}}
                                </span>
                                <div>
                                    <h5>
                                        {{dl.gstibo_name}} ${{dl.gstibo_value}}
                                    </h5>
                                    <p style="margin-bottom:0;">
                                        <strong>
                                            Sales rep:
                                        </strong>
                                        {{dl.gstibo_salesrep}}
                                    </p>
                                    <p style="margin-bottom:0;">
                                        <strong>
                                            Sales cycle length
                                        </strong>
                                        {{dl.gstibo_days}}
                                    </p>

                                </div>
                            </li>

                        </ul>
                    </div>
                </aside>
            </div>

        </div>
        <div class="content-wraper" *ngSwitchCase="'T8'">
            <div class="recrdashboard">

                <h2>
                    Recruitment Dashboard
                </h2>
                <div class="heighlitcolmns">
                    <div *ngIf="recruirtmenttiles[0]" class="colmn">
                        <h4>
                            {{recruirtmenttiles[0].gstibo_item}}

                        </h4>
                        <div class="numbervalue">
                            <h3> {{recruirtmenttiles[0].gstibo_value}} </h3>

                        </div>
                    </div>
                    <div *ngIf="recruirtmenttiles[1]" class="colmn">
                        <h4>
                            {{recruirtmenttiles[1].gstibo_item}}

                        </h4>
                        <div class="numbervalue">
                            <h3>{{recruirtmenttiles[1].gstibo_value}}</h3>

                        </div>
                    </div>
                    <div *ngIf="recruirtmenttiles[2]" class="colmn">
                        <h4>

                            {{recruirtmenttiles[2].gstibo_item}}
                        </h4>
                        <div class="numbervalue">
                            <h3>{{recruirtmenttiles[2].gstibo_value}}</h3>

                        </div>
                    </div>
                </div>

                <div class="whiteblocks plusone">
                    <div class="columbox">
                        <div class="newcolumtitlles">
                            <h4>
                                {{dashboardTemplateForm.value.chartBlock1Title}}
                            </h4>

                        </div>

                        <div id="columnchart_values" style="height: 23rem;">
                            <app-chart-controls [chartForm]="chartForm1"></app-chart-controls>
                        </div>

                    </div>
                    <div class="columbox">
                        <div class="newcolumtitlles">
                            <h4>
                                {{dashboardTemplateForm.value.chartBlock2Title}}
                            </h4>

                        </div>
                        <div id="newpiechart" style="height: 23rem;">
                            <app-chart-controls [chartForm]="chartForm3"></app-chart-controls>
                        </div>
                    </div>
                    <div class="columbox">
                        <div class="newcolumtitlles">
                            <h4>
                                {{dashboardTemplateForm.value.chartBlock3Title}}
                            </h4>

                        </div>
                        <div class="funnelwithvalue">
                            <ul class="newfunnelvalue">
                                <li *ngFor="let item of recruitmentFunnel">
                                    {{item.gstibo_Item}}: {{item.gstibo_value}}%
                                </li>

                            </ul>
                            <ul class="newfunnel">
                                <li *ngFor="let item of recruitmentFunnel">
                                    <span>&nbsp;</span>
                                </li>

                            </ul>
                        </div>
                    </div>
                    <div class="columbox">
                        <div class="newcolumtitlles">
                            <h4>
                                {{dashboardTemplateForm.value.chartBlock4Title}}
                            </h4>

                        </div>
                        <div id="series_chart_div" style="height: 23rem;">
                            <app-chart-controls [chartForm]="chartForm4"></app-chart-controls>
                        </div>
                    </div>
                </div>
                <div class="whiteblocks">
                    <div class="columbox">
                        <div class="newcolumtitlles">
                            <h4>
                                {{dashboardTemplateForm.value.chartBlock6Title}}
                            </h4>

                        </div>
                        <div id="curve_chart" style="height: 23rem;">
                            <app-chart-controls [chartForm]="chartForm6"></app-chart-controls>
                        </div>
                    </div>
                    <div class="columbox">
                        <div class="newcolumtitlles">
                            <h4>
                                {{dashboardTemplateForm.value.chartBlock5Title}}
                            </h4>

                        </div>
                        <div class="circlebars">
                            <div [attr.role]="item.color" *ngFor="let item of chartForm5.controls['data'].value"
                                aria-valuemin="0" aria-valuemax="100" [style.--value]="item.value">
                                <!-- {{item.name}}-{{item.value}}-{{}} -->
                            </div>
                            <!-- <div role="progresspinkbar" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style="--value:75"></div>
                    <div role="progressgreenbar" aria-valuenow="55" aria-valuemin="0" aria-valuemax="100" style="--value:55"></div>
                    <div role="progressbluebar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100" style="--value:25"></div>
                    <div role="progressyellowbar" aria-valuenow="15" aria-valuemin="0" aria-valuemax="100" style="--value:15"></div> -->
                        </div>
                        <div class="circlebullet">
                            <p *ngFor="let item of chartForm5.controls['columnNames'].value"><span
                                    [className]="item.color"></span>{{item.name}} </p>
                            <!-- <p><span class="pink"></span>Jtsi website</p>
            <p><span class="green"></span>Reffrel</p>
            <p><span class="blue"></span>Talent Management</p>
            <p><span class="yellow"></span>others</p> -->
                        </div>
                    </div>
                    <div class="columbox">
                        <div class="newcolumtitlles">
                            <h4>
                                {{dashboardTemplateForm.value.chartBlock7Title}}
                            </h4>

                        </div>
                        <!-- <div id="dealsourceChart" style="height: 23rem;"></div> -->

                        <div class="orangebars" *ngFor="let od of offerDecline">
                            <p> {{od.gstibo_item}} <span>{{od.gstibo_per}}</span></p>
                            <div class="thinprogress">
                                <div [className]="od.color" [style.width.%]="od.gstibo_per"></div>
                            </div>
                        </div>

                    </div>
                </div>


            </div>
        </div>

        <div class="content-wraper" *ngSwitchCase="'T5'">

            <div class="oppertunitydb">
                <h2>
                    Opportunity Dashboard
                </h2>

                <div class="oppertunitydbcontent">
                    <aside>
                        <div class="asidebox">
                            <div class="newcolumtitlles">
                                <h4>
                                    Top 10 Open Opportunities
                                </h4>

                            </div>
                            <table class="chartable2" (click)="navigatePagetoOpertunity()">


                                <thead>
                                    <tr>
                                        <th>Opportunities Name</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tr *ngFor="let item of top10Opportunity">

                                    <td>{{item.gstibo_Name}}</td>
                                    <td *ngIf="item.gstibo_status=='Open'" class="greentxt">{{item.gstibo_status}}</td>
                                    <td *ngIf="item.gstibo_status=='Closed'" class="redtxt">{{item.gstibo_status}}</td>
                                </tr>
                                <!-- <tr>
    
                                               <td >ACme</td>
                                               <td class="greentxt">Open</td>
                                            </tr>
                                            <tr>
                                                   <td >IBM</td>
                                                   <td class="redtxt">Closed</td>
                                            </tr>
                                            <tr>
                                                   <td >Cloudamp LLC</td>
                                                   <td class="greentxt">Open</td>
                                            </tr>
                                            <tr>
                                                   <td >Microsoft Corporation</td>
                                                   <td class="greentxt">open</td>
                                             </tr>
    
                                             <tr>
                                                   <td >Acme</td>
                                                   <td class="redtxt">Closed</td>
                                             </tr>
                                             <tr>
                                                   <td >Acme</td>
                                                   <td class="redtxt">Closed</td>
                                             </tr>
                                             <tr>
                                                   <td >Acme</td>
                                                   <td class="greentxt">Open</td>
                                             </tr>
                                             <tr>
                                                   <td >Acme</td>
                                                   <td class="redtxt">Closed</td>
                                             </tr> -->

                            </table>
                        </div>
                        <div class="asidebox">
                            <div class="newcolumtitlles">
                                <h4>
                                    Top 10 Won Opportunities
                                </h4>

                            </div>
                            <table (click)="navigatePagetoOpertunity()">
                                <thead>
                                    <tr>
                                        <th>Opportunities Name</th>
                                        <th>Amount</th>
                                    </tr>
                                </thead>
                                <tr *ngFor="let item of top10wonOpportunity">
                                    <td>{{item.gstibo_Name}}</td>
                                    <td>{{item.gstibo_Amount}}</td>
                                </tr>
                                <!-- <tr>
                                                 <td >Acme</td>
                                                 <td>$250</td>
                                          </tr>
                                          <tr>
                                                 <td >Acme</td>
                                                 <td>$250</td>
                                          </tr>
                                          <tr>
                                                 <td >Acme</td>
                                                 <td>$250</td>
                                           </tr>
    
                                           <tr>
                                                 <td >Acme</td>
                                                 <td>$250</td>
                                           </tr>
                                           <tr>
                                                 <td >Acme</td>
                                                 <td>$250</td>
                                           </tr> -->

                            </table>
                        </div>


                    </aside>
                    <article>


                        <div class="heighlitcolmns">
                            <div *ngIf="leadTiles[0]" class="colmn">
                                <h4>
                                    {{leadTiles[0].gstibo_item}}
                                </h4>
                                <div class="numbervalue">
                                    <h3>{{leadTiles[0].gstibo_value}} </h3>
                                </div>
                            </div>
                            <div *ngIf="leadTiles[1]" class="colmn">
                                <h4>
                                    {{leadTiles[1].gstibo_item}}
                                </h4>
                                <div class="numbervalue">
                                    <h3>{{leadTiles[1].gstibo_value}} </h3>
                                </div>
                            </div>
                            <div *ngIf="leadTiles[2]" class="colmn">
                                <h4>
                                    {{leadTiles[2].gstibo_item}}
                                </h4>
                                <div class="numbervalue">
                                    <h3>{{leadTiles[2].gstibo_value}} </h3>
                                </div>
                            </div>
                            <div *ngIf="leadTiles[3]" class="colmn">
                                <h4>
                                    {{leadTiles[3].gstibo_item}}
                                </h4>
                                <div class="numbervalue">
                                    <h3>{{leadTiles[3].gstibo_value}} </h3>
                                </div>
                            </div>
                            <!-- <div class="colmn">
                            <h4>OPEN OPPERTUNITY </h4>
                            <div class="numbervalue">
                                   <h3>158 </h3>
    
                            </div>
                     </div>
                     <div class="colmn">
                            <h4>EXPECTED REVENUE</h4><br>
    
                            <div class="numbervalue">
                                   <h3>$1.21M</h3>
    
                            </div>
                     </div>
    
                     <div class="colmn">
                            <h4>
                                   REVENUE WON
                            </h4>
                            <div class="numbervalue">
                                   <h3>$0.63M</h3>
    
                            </div>
                     </div>
    
                     <div class="colmn">
                            <h4>
                                   Over Success Rate
                            </h4>
                            <div class="numbervalue">
                                   <h3>$0.63M</h3>
    
                            </div>
                     </div> -->

                        </div>

                        <div class="whiteblocks">
                            <div class="columbox">
                                <div class="newcolumtitlles">

                                    <h4>
                                        <!-- Revenue Closed This Quarter -->
                                        {{dashboardTemplateForm.value.chartBlock1Title}}
                                    </h4>

                                </div>
                                <div class="centerdgrid">
                                    <div id="TotalValueChart" style="height: 23rem;">
                                        <app-chart-controls [chartForm]="chartForm1"></app-chart-controls>
                                    </div>
                                </div>
                            </div>

                            <div class="columbox">
                                <div class="newcolumtitlles">
                                    <h4>
                                        <!-- Deals Won Vs By Owner -->
                                        {{dashboardTemplateForm.value.chartBlock2Title}}
                                    </h4>


                                </div>

                                <div id="barchart_material" style="height: 20rem;">
                                    <app-chart-controls [chartForm]="chartForm2"></app-chart-controls>
                                </div>

                            </div>

                            <div class="columbox">
                                <div class="newcolumtitlles">
                                    <h4>
                                        <!-- Opportunities By Campaign Types -->
                                        {{dashboardTemplateForm.value.chartBlock3Title}}
                                    </h4>
                                </div>
                                <div id="donutchart" style="height: 20rem;">
                                    <app-chart-controls [chartForm]="chartForm3"></app-chart-controls>
                                </div>
                            </div>




                            <!-- End -->
                        </div>

                        <div class="whiteblocks lessone">
                            <div class="columbox">
                                <div class="newcolumtitlles">
                                    <h4>
                                        <!-- Estimated Vs.Actual Revenue By month -->
                                        {{dashboardTemplateForm.value.chartBlock4Title}}
                                    </h4>

                                </div>

                                <div id="bar_chart" style="height: 22rem;">
                                    <app-chart-controls [chartForm]="chartForm4"></app-chart-controls>
                                </div>

                            </div>

                            <div class="columbox">
                                <div class="newcolumtitlles">
                                    <h4>
                                        <!-- Task Completion -->
                                        {{dashboardTemplateForm.value.chartBlock5Title}}
                                    </h4>

                                </div>
                                <div id="stackedbar_chart" style="height: 22rem;">
                                    <app-chart-controls [chartForm]="chartForm5"></app-chart-controls>
                                </div>



                            </div>






                            <!-- End -->
                        </div>
                    </article>
                </div>
            </div>

        </div>
        <div class="content-wraper" *ngSwitchCase="'T10'">
            <div class="newjtsdbhr">
                <!-- <div class="slidercolm" style="grid-template-columns: 1fr auto;">
                    <article>
                        <h3 *ngIf="!isgusa">
                            Announcements
                        </h3>
                        <app-bulletin-release></app-bulletin-release>

                    </article>
                    <picture style="padding-right: 2rem;">
                        <img style="max-height: 17rem;" src="./assets/img/oghrdb.png" alt="">
                    </picture>
                </div> -->
                <div style="padding: 1.5rem 2rem 1rem 2rem; ">
                    <div class="slidercolm"
                        style="background-image:'url(./assets/img/procurementbannerbg.jpg)';overflow: hidden; border-radius: 2rem; align-content: flex-end; display: grid; grid-template-columns: auto minmax(auto, 25rem); column-gap: 1.5rem; background-size:cover; background-position: right center; align-items: center;">
                        <article>
                            <h2 style="margin-bottom: 1rem; font-size:2.5rem; font-weight:900; color: #172B4C;">
                                Employee Management Dashboard
                            </h2>
                            <p style="font-size:1.4rem;">
                                Employee Management Module is a comprehensive solution designed to streamline and
                                enhance
                                every aspect of human resource management. It provides a centralized platform for
                                managing employee data. facilitating HR processes, and improving overall workforce
                                efficiency.
                                In addition, the module includes an Expense Report and Approval features,
                                enabling employees to submit expenses seamlessly and allowing managers to review and
                                approve them efficiently the same system.
                            </p>
                        </article>
                        <picture style="margin-left: auto;">
                            <img src="./assets/img/contactsbannerimage.png" style="width: 100%;"
                                alt="contactsbannerimage">
                        </picture>
                    </div>
                </div>
                <div class="bottomdivisions" style="padding: 0 2rem;">
                    <div class="leftcolmns">
                        <div class="leftcolmns-top">
                            <div class="clmnbox">
                                <div class="title">
                                    <h4>
                                        Timesheet / Time Off Status
                                    </h4>
                                    <div class="rightsideoptions">
                                        <select name="" id="" (change)="ontimesheetweekchange($event)">
                                            <option value='{{itm.id}}' *ngFor="let itm of (Weekoptiontype)"
                                                [selected]="(itm.id == '0')">{{itm.name}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="datagridone">
                                    <app-user-timesheet-status-dashboard [data]="timesheetweek">
                                    </app-user-timesheet-status-dashboard>
                                </div>
                            </div>
                            <div class="clmnbox ">
                                <div class="title">
                                    <h4>
                                        {{dashboardTemplateForm.value.chartBlock1Title}}
                                    </h4>
                                    <div class="rightsideoptions">
                                        <select *ngIf="projectListData.length>0" (change)="onPrjEmplist_change($event)">
                                            <option value='{{itm.gstibo_project_id}}'
                                                *ngFor="let itm of (projectListData)"
                                                [selected]="(itm.gstibo_project_id == defaultEmpProjectId  ? true : false)">
                                                {{itm.gstibo_project_name}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div style="height:20rem;align-content:flex-end;display:grid;">
                                    <div id="dealsourceChart" (click)="navigatePage()">
                                        <app-chart-controls [chartForm]="chartForm1"></app-chart-controls>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="leftcolmns-bottom">
                            <div class="clmnbox" *ngIf="usertype=='Admin'">
                                <app-dashboard-birthday-anniversary [data]="'HR'"></app-dashboard-birthday-anniversary>

                            </div>
                            <div class="clmnbox" *ngIf="usertype=='User'">
                                <app-dashboard-event-notification></app-dashboard-event-notification>
                            </div>
                            <div class="clmnbox">
                                <app-dashboard-todo-list-alt [data]="'HR'"></app-dashboard-todo-list-alt>

                            </div>
                        </div>
                    </div>
                    <div class="clmnbox" id="projectdetails" style="height: auto;" *ngIf="usertype=='User'">
                        <div class="title">
                            <h4>
                                Assigned Project Details
                            </h4>
                        </div>
                        <div class="colmcontent-dash">
                            <app-dashboard-projcet-details></app-dashboard-projcet-details>
                            <picture class="mx-auto" *ngIf="!isEmployeeMgmtDashboardProjectPresent">
                                <img src="./assets/img/Schedule-Meeting.png" alt="">
                            </picture>
                        </div>
                    </div>
                    <div class="clmnbox" *ngIf="usertype=='Admin'">
                        <div class="title">
                            <h4>
                                Scheduled meeting
                            </h4>
                            <!-- <button class="newiconlink red" title="Click to Schedule Meeting"
                                (click)="redirecttomeeting();">
                                <svg>
                                    <use xlink:href="./assets/img/sprite.svg#zoom"></use>
                                </svg>
                            </button> -->
                        </div>
                        <div class="colmcontent">
                            <div class="newtabtns">
                                <button [ngClass]="{'active':activemeeting}" title="Click to Zoom meeting"
                                    (click)="Zoommeetingclick()">
                                    Zoom meeting
                                </button>
                                <button (click)="teamsmeetingclick()" [ngClass]="{'active':!activemeeting}"
                                    title="Click to Team meeting">
                                    Team meeting
                                </button>
                            </div>
                            <div class="newtabcontents">
                                <h4>
                                    Select meeting
                                </h4>
                                <input class="comninput" type="text" (change)="searchmeeting($event)">
                                <ul class="newmeetinglist" *ngIf="MeetingList1.length>0">
                                    <li *ngFor="let item of MeetingList1">
                                        <span>{{item.Hostby}} {{item.Topic}} - {{item.StartTime}}</span>
                                        <a title="Click to join meeting" href="{{item.JoinUrl}}" target="_blank">
                                            Click here
                                        </a>
                                        <!-- <div class="radioGroup">
                                    <input type="checkbox" (change)="clickonmetting(item.JoinUrl)"  id="check_1" class="toggleBtn" value="1" checked>
                                    <label for="check_1"></label>
                                  </div> -->
                                    </li>
                                    <!-- <li>
                                    <span>Meeting OG</span> 
                                    <div class="radioGroup">
                                        
                                      </div>
                                 </li> -->

                                </ul>
                            </div>
                            <picture>
                                <img src="./assets/img/Schedule-Meeting.png" alt="">
                            </picture>
                        </div>
                    </div>
                </div>
                <footer *ngIf="isNotLoading" class="center-footer">
                    <p [innerHtml]="labelMessages.copyright.copyright_message"></p>
                </footer>
            </div>
            <!-- <div class="empdashboardgstiusa">
            <article>
                <h2>
                    Dashboard Overview
                </h2>
                <div class="whiteblocks">
                    <div class="columbox">
                        <div class="newcolumtitlles">
    
                            <h4>
                                Bulletin
                            </h4>
                        </div>
                        <div class="clmncontent">
                            <div style="overflow-y: auto; display: grid; height: 20rem; cursor:pointer;">
                                <app-bulletinnew></app-bulletinnew>
                            </div>
                        </div>
                    </div>
                    <div class="columbox">
    
                        <div class="newcolumtitlles">
                            <h4>
                                Birthday / Anniversary
                            </h4>
                            <div class="rightsideoptions spriteBtns">
                                <button>
                                    <svg>
                                        <use xlink:href="./assets/img/sprite.svg#eyeview"></use>
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <div class="clmncontent">
                            <div style="overflow-y: auto; display: grid; height: 20rem; cursor:pointer;">
                                <app-todays-event></app-todays-event>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="whiteblocks">
                    <div class="columbox">
                        <div class="newcolumtitlles">
                            <h4>
                                {{dashboardTemplateForm.value.chartBlock1Title}}
                            </h4>
                            <div class="rightsideoptions">
                                <select *ngIf="projectListData.length>0" (change)="onPrjEmplist_change($event)">
                                    <option value='{{itm.gstibo_project_id}}' *ngFor="let itm of (projectListData)"
                                        [selected]="(itm.gstibo_project_id == defaultEmpProjectId  ? true : false)">
                                        {{itm.gstibo_project_name}}
                                    </option>
                                </select>
    
                                
                            </div>
                        </div>
                        <div class="clmncontent">
                            <div id="dealsourceChart" (click)="navigatePage()">
                                <app-chart-controls [chartForm]="chartForm1"></app-chart-controls>
                            </div>
                        </div>
                    </div>
                    <div class="columbox">
                        <div class="newcolumtitlles">
                            <h4>
                                Time Sheet / Time Off Status
                            </h4>
                            <div class="rightsideoptions">
                                <select name="" id="" (change)="ontimesheetweekchange($event)">
                                    <option value='{{itm.id}}' *ngFor="let itm of (Weekoptiontype)"
                                        [selected]="(itm.id == '0')">{{itm.name}}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="clmncontent">
                            <div id="dealsourceChart">
                                <app-user-timesheet-status-dashboard
                                    [data]="timesheetweek"></app-user-timesheet-status-dashboard>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="whiteblocks" style="display:none;">
                    <div class="columbox">
                        <div class="newcolumtitlles">
                            <h4>
                                Time Off details <small>- Past 6 months</small>
                            </h4>
                            <div class="rightsideoptions">
    
                                <select name="" id="">
                                    <option value="">
                                        All
                                    </option>
                                    <option value="">
                                        Current status
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div id="columnchart_material">
                            <app-chart-controls [chartForm]="chartForm3"></app-chart-controls>
                        </div>
                    </div>
                    <div class="columbox">
                        <div class="newcolumtitlles">
                            <h4>
                                Time Off Status
                            </h4>
                            <div class="rightsideoptions">
                                <select name="" id="" (change)="ontimeoutweekchange($event)">
                                    <option value='{{itm.id}}' *ngFor="let itm of (Weekoptiontype)"
                                        [selected]="(itm.id == '0')">{{itm.name}}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div id="employees">
                            <app-user-timeout-status-dashboard [data]="timeoutweek"></app-user-timeout-status-dashboard>
                        </div>
                    </div>
                </div>
            </article>
            <aside style="grid-template-rows:6rem auto;">
                <div class="asidebox">
                    <div class="clmncontent">
                        <app-event-mailbox-buttons></app-event-mailbox-buttons>
                    </div>
                </div>
                <div class="asidebox">
                    <div class="newcolumtitlles">
                        <h4>
                            Schedule Meeting
                        </h4>
                        <div class="rightsideoptions">
                            <button title="Schedule Meeting" (click)="redirecttomeeting();">
                                <svg>
                                    <use xlink:href="./assets/img/sprite.svg#zoom"></use>
                                </svg>
                            </button>
                        </div>
                    </div>
                    <div class="clmncontent">
                        <div style="max-height: 27rem; overflow-y:auto" *ngIf="MeetingList.length>0">
                            <ul class="newmeetings">
                                <li *ngFor="let item of MeetingList">
    
                                    <p>
                                        <strong>Schedule By: {{item.Hostby}}</strong>
                                        {{item.Topic}} - {{item.StartTime}}
                                    </p>
    
                                    <a href="{{item.JoinUrl}}" target="_blank">
                                        Click here
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
    
                <div class="asidebox">
                    <app-dashboard-to-do-listnew> </app-dashboard-to-do-listnew>
    
                </div>
            </aside>
        </div> -->
        </div>

        <div class="content-wraper" *ngSwitchCase="'T11'">

            <div class="empdashboard">
                <article>
                    <h2>
                        Dashboard Overview
                    </h2>
                    <app-dashboard-colored-columnnew [customtile]="Contact"></app-dashboard-colored-columnnew>

                    <div class="whiteblocks single">
                        <div class="newcolumtitlles">
                            <h4>
                                Bulletin
                            </h4>
                        </div>
                        <div style="overflow-y: auto; display: grid; height: 12rem; cursor:pointer;">
                            <app-bulletinnew></app-bulletinnew>
                        </div>
                    </div>
                    <div class="whiteblocks single">
                        <div class="newcolumtitlles">
                            <h4>
                                Newly Added Contacts
                            </h4>
                        </div>
                        <div *ngIf="contactlist.length>0" style="height: 31.7rem; overflow-y:auto;">
                            <div class="contactslistnew" *ngFor="let item of contactlist">
                                <picture>
                                    <img src="http://bostg.gstiusa.com/assets/img/user_one.jpg" alt="">
                                </picture>
                                <article>
                                    <div class="detail">
                                        <p>
                                            <strong>{{item.gstibo_full_name}}</strong>
                                        </p>
                                        <p>
                                            {{item.gstibo_email_address}}
                                            <br>
                                            {{item.gstibo_phone_home}}
                                        </p>
                                    </div>
                                    <div class="spriteBtns">
                                        <button>
                                            <svg>
                                                <use xlink:href="./assets/img/sprite.svg#edits"></use>
                                            </svg>
                                        </button>
                                    </div>
                                </article>
                            </div>
                        </div>
                        <!-- <div class="contactslistnew">
                        <picture>
                                <img src="http://bostg.gstiusa.com/assets/img/user_one.jpg" alt="">
                        </picture>
                        <article>
                            <div class="detail">
                            <p>
                              <strong>kevin Oh</strong>  
                            </p>
                            <p>
                                kevinoh@something.com
                                <br>
                                9412340987
                            </p>
                        </div>
                        <div class="spriteBtns">
                            <button>
                                <svg>
                                    <use xlink:href="./assets/img/sprite.svg#edits"></use>
                                </svg>                            
                            </button>
                        </div>                    
                    </article>
                    </div>
                    <div class="contactslistnew">
                        <picture>
                                <img src="http://bostg.gstiusa.com/assets/img/user_one.jpg" alt="">
                        </picture>
                        <article>
                            <div class="detail">
                            <p>
                              <strong>Mawghan McCab</strong>  
                            </p>
                            <p>
                                anand@something.com
                                <br>
                                9412340987
                            </p>
                        </div>
                        <div class="spriteBtns">
                            <button>
                                <svg>
                                    <use xlink:href="./assets/img/sprite.svg#edits"></use>
                                </svg>                            
                            </button>
                        </div>                    
                    </article>
                    </div>
                    <div class="contactslistnew">
                        <picture>
                                <img src="http://bostg.gstiusa.com/assets/img/user_one.jpg" alt="">
                        </picture>
                        <article>
                            <div class="detail">
                            <p>
                              <strong>Anand Balakrishnana</strong>  
                            </p>
                            <p>
                                anand@something.com
                                <br>
                                9412340987
                            </p>
                        </div>
                        <div class="spriteBtns">
                            <button>
                                <svg>
                                    <use xlink:href="./assets/img/sprite.svg#edits"></use>
                                </svg>                            
                            </button>
                        </div>                    
                    </article>
                    </div>
                    <div class="contactslistnew">
                        <picture>
                                <img src="http://bostg.gstiusa.com/assets/img/user_one.jpg" alt="">
                        </picture>
                        <article>
                            <div class="detail">
                            <p>
                              <strong>Anand Balakrishnana</strong>  
                            </p>
                            <p>
                                anand@something.com
                                <br>
                                9412340987
                            </p>
                        </div>
                        <div class="spriteBtns">
                            <button>
                                <svg>
                                    <use xlink:href="./assets/img/sprite.svg#edits"></use>
                                </svg>                            
                            </button>
                        </div>                    
                    </article>
                    </div> -->
                    </div>
                </article>
                <aside style="grid-template-rows:6rem auto;">
                    <div class="asidebox">
                        <app-event-mailbox-buttons></app-event-mailbox-buttons>
                    </div>
                    <div class="asidebox">
                        <div class="newcolumtitlles">
                            <h4>
                                Schedule Meeting
                            </h4>
                            <div class="rightsideoptions">
                                <button title="Schedule Meeting" (click)="redirecttomeeting();">
                                    <svg>
                                        <use xlink:href="./assets/img/sprite.svg#zoom"></use>
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <div style="max-height: 27rem; overflow-y:auto" *ngIf="MeetingList.length>0">
                            <ul class="newmeetings">
                                <li *ngFor="let item of MeetingList">

                                    <p>
                                        <strong>Schedule By: {{item.Hostby}}</strong>
                                        {{item.Topic}} - {{item.StartTime}}
                                    </p>

                                    <a href="{{item.JoinUrl}}" target="_blank">
                                        Click here
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="asidebox">
                        <!-- <app-profile-detailsnew *ngIf="empasidebox[0].gstibo_chart_heading=='Profile Details'">
                    </app-profile-detailsnew> -->
                        <app-dashboard-to-do-listnew> </app-dashboard-to-do-listnew>

                    </div>
                    <!-- <div *ngFor="let item of empasidebox" class="asidebox">
                        
                     <app-profile-detailsnew *ngIf="item.gstibo_chart_heading=='Profile Details'"></app-profile-detailsnew> 
    
                    <app-absent-employee-listnew *ngIf="item.gstibo_chart_heading=='Absent Employee'">
                    </app-absent-employee-listnew>
                </div> -->
                </aside>
                <!-- <aside *ngIf="empasidebox.length==0">
                <div class="asidebox">
                    <app-profile-detailsnew></app-profile-detailsnew>
                
                    <app-absent-employee-listnew></app-absent-employee-listnew>
                </div>
            </aside> -->
            </div>

        </div>


        <div class="content-wraper" *ngSwitchCase="'T12'">
            <div class="newjtsdb" *ngIf="!ismcf">

                <div>
                    <div class="slidercolm" style="grid-template-columns: 1fr minmax(auto, 40rem);" *ngIf="ismcf">
                        <article>
                            <h2 style="margin-bottom: 1rem; font-size:2rem; font-weight:900; color: #172B4C;">
                                Contacts Dashboard
                            </h2>
                            <p style="font-size:1.4rem;">
                                The Contacts Module is a centralized system to manage key contact information, including
                                Customers,Vendors, and extrnal partners.
                                It allows users to add,update and categarized contacts with details like
                                name,organization,email,phone number and location with serach and filter options,
                                role-based access and integration with other modules, it ensures easy access, secure
                                sharing,
                                and streamline communication across the organization.
                            </p>
                        </article>
                    </div>
                </div>

                <div style="padding: 1.5rem 2rem 1rem 2rem; ">
                    <div class="slidercolm"
                        style="background-image:'url(./assets/img/procurementbannerbg.jpg)';overflow: hidden; border-radius: 2rem; align-content: flex-end; display: grid; grid-template-columns: auto minmax(auto, 25rem); column-gap: 1.5rem; background-size:cover; background-position: right center; align-items: center;">
                        <article>
                            <h2 style="margin-bottom: 1rem; font-size:2.5rem; font-weight:900; color: #172B4C;">
                                Contacts Dashboard
                            </h2>
                            <p style="font-size:1.4rem;">
                                The Contacts Module is a centralized system to manage key contact information, including
                                Customers,Vendors, and extrnal partners.
                                It allows users to add,update and categarized contacts with details like
                                name,organization,email,phone number and location with serach and filter options,
                                role-based access and integration with other modules, it ensures easy access, secure
                                sharing,
                                and streamline communication across the organization.
                            </p>
                        </article>
                        <picture style="margin-left: auto;">
                            <img src="./assets/img/contactsbannerimage.png" style="width: 100%;"
                                alt="contactsbannerimage">
                        </picture>
                    </div>
                </div>

                <!-- <div class="slidercolm" style="grid-template-columns: auto 30rem;" *ngIf="ismcf">
                    <article>
                        <h3>
                            Bulletin
                        </h3>
                        <app-bulletin-release></app-bulletin-release>
            
                    </article>
                    <picture>
                        <img src="./assets/img/img_bulletin_right.jpg" alt="">
                    </picture>
                </div> -->
                <div class="bottomdivisions" style="grid-template-columns: 1fr; padding: 0 2rem;">
                    <div class="leftcolmns" style="grid-template-columns: 1.5fr 1fr 1fr;column-gap: 1rem;">
                        <div class="clmnbox">
                            <div class="title" style="margin-bottom: 0.5rem;">
                                <h4 class="titleBold">
                                    Recent contacts
                                </h4>
                                <button class="btndark" title="Click to view all contacts"
                                    (click)="Redircttocontactpage()">
                                    View all
                                </button>
                            </div>
                            <div class="datagridone"
                                style="min-height: 18rem;margin: 0.5rem;border: 1px solid #CDCDCD;border-radius: 7px;">
                                <article>
                                    <div style="max-height: 18rem; overflow-y: auto;">
                                        <ul class="datagridone_contents bold"
                                            style="background-color: #ededf5;border-radius: 0.75rem .75rem 0 0;">
                                            <li style="padding-left: 1rem;">
                                                Name
                                            </li>
                                            <li>
                                                Title
                                            </li>
                                            <li>
                                                Company Name
                                            </li>
                                            <li>
                                                Quick links
                                            </li>
                                        </ul>
                                        <ul class="datagridone_contents" *ngFor="let item of contactlist"
                                            style="border-bottom: 1px solid #dddcee;">
                                            <li style="padding-left: 1rem;">
                                                <img src="./assets/img/avatar.png" alt="">
                                                <p>
                                                    {{item.gstibo_full_name}}
                                                </p>
                                            </li>
                                            <li>
                                                {{ item.gstibo_job_title }}
                                            </li>
                                            <li>
                                                {{item.gstibo_company}}
                                            </li>
                                            <li>

                                                <a href="tel:{{item.gstibo_phone_home}}" target="_blank">
                                                    <button title="Click to call" class="newiconlink green">
                                                        <svg>
                                                            <use xlink:href="./assets/img/sprite.svg#call"></use>
                                                        </svg>
                                                    </button>
                                                </a>
                                                <a href="mailto:{{item.gstibo_email_address}}" target="_blank">
                                                    <button title="Click to mail" class="newiconlink blue">
                                                        <svg>
                                                            <use xlink:href="./assets/img/sprite.svg#mail"></use>
                                                        </svg>
                                                    </button>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </article>
                            </div>
                        </div>
                        <div class="clmnbox ">
                            <app-dashboard-contact-status></app-dashboard-contact-status>
                        </div>
                        <div class="clmnbox">
                            <div class="title" style="margin-bottom: 0.5rem;">
                                <h4 class="titleBold">
                                    Total Contacts
                                </h4>
                            </div>
                            <div id="columnchart_material" style="padding-top: 1.5rem !important;">
                                <app-chart-controls [chartForm]="chartFormcon"></app-chart-controls>
                            </div>
                        </div>
                    </div>
                    <div class="leftcolmns"
                        style="grid-template-columns: 1fr 1.5fr 1fr;column-gap: 1rem;margin-top: .75rem;">
                        <div class="clmnbox">
                            <div class="title">
                                <h4 class="titleBold">
                                    Outlook
                                </h4>
                                <div style="display: inline-flex; column-gap: .5rem; margin-left: auto;">
                                    <button *ngIf="!msAuthService.authenticated" (click)="signInOutlook()"
                                        style="cursor: pointer;" class="bgcolor_01" title="Sign In Microsoft Account">
                                        LogIn
                                    </button>
                                    <button *ngIf="msAuthService.authenticated" (click)="signOutOutlook()"
                                        style="cursor: pointer;" class="bgcolor_01"
                                        title="Logout from Microsoft Account">
                                        Logout
                                    </button>
                                    <button class="btndark" title="Click to view all outlook" (click)="viewemail()">

                                        View all
                                    </button>
                                </div>
                            </div>

                            <div style="height: 17rem;">
                                <div class="main-list " *ngIf="msAuthService.authenticated">
                                    <div class="outlookmodal-main">
                                        <div class="outlookmodalcontent">
                                            <div *ngFor="let mainmail of groupmail">
                                                <ng-container>
                                                    <ul *ngFor="let submail of mainmail.mails">
                                                        <li>
                                                            <div class="mail-item"
                                                                (click)="loadMessage('' + submail.id + '')">
                                                                <div class="mail-from" style="font-weight: 700;">
                                                                    {{submail.From}}</div>
                                                                <div class="mailSubRow">
                                                                    <div class="mail-sub mail-item-bottom ellipsis quarter-ellipsis2"
                                                                        title="{{submail.Subject}}">
                                                                        {{submail.Subject}}
                                                                    </div>
                                                                    <div class="mail-lst-dt">
                                                                        {{convertTimeToLocal(submail.Recevied)}}</div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="clmnbox">
                            <app-dashboard-todo-list-alt [data]="'CONTACTS'"></app-dashboard-todo-list-alt>

                        </div>
                        <div class="clmnbox">
                            <div class="title">
                                <div>
                                    <h4 class="titleBold">
                                        Scheduled meeting
                                    </h4>
                                </div>
                                <div>
                                    <div style="display: inline-flex; column-gap: .5rem; margin-left: auto;">
                                        <button *ngIf="!msAuthService?.user" (click)="signInOutlook()"
                                            style="cursor: pointer;" class="bgcolor_01"
                                            title="Sign In Microsoft Account">
                                            LogIn
                                        </button>
                                        <button *ngIf="msAuthService?.user" (click)="signOutOutlook()"
                                            class="bgcolor_01" style="cursor: pointer;"
                                            title="Logout from Microsoft Account">
                                            Logout
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="colmcontent">
                                <div class="newtabcontents" *ngIf="msAuthService.authenticated">
                                    <ul class="newmeetinglist contact-outlook-meeting-list"
                                        *ngIf="calenderEvents?.length > 0">
                                        <li *ngFor="let event of calenderEvents" class="contact-outlook-meeting">
                                            <span>
                                                <strong>Schedule By: {{ event?.organizer }}</strong>
                                                <p class="outlook-contact-details-meeting-text" [title]="event?.title">
                                                    {{ event?.title }}
                                                </p>
                                            </span>
                                            <a *ngIf="event?.onlineMeetingUrl" class="outlook-contact-meeting-link"
                                                href="{{event?.onlineMeetingUrl}}" target="_blank">
                                                <button class="btndarkcon" title="Click to open link">
                                                    Click here
                                                </button>
                                            </a>
                                            <a *ngIf="!event?.onlineMeetingUrl" class="outlook-contact-meeting-link">
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <footer *ngIf="isNotLoading" class="center-footer">
                    <p [innerHtml]="labelMessages.copyright.copyright_message"></p>
                </footer>
            </div>

            <div class="newjtsdb" *ngIf="ismcf">
                <div style="padding: 1.5rem 2rem 1rem 2rem; ">
                    <div class="slidercolm"
                        style="background-image:'url(./assets/img/procurementbannerbg.jpg)';overflow: hidden; border-radius: 2rem; align-content: flex-end; display: grid; grid-template-columns: auto minmax(auto, 20rem); column-gap: 1.5rem; background-size:cover; background-position: right center; align-items: center;">
                        <article>
                            <h2 style="margin-bottom: 1rem; font-size:2.5rem; font-weight:900; color: #172B4C;">
                                Administrative Dashboard
                            </h2>
                            <p style="font-size:1.4rem;">
                                Transform the way you manage operations with our all-new Administrative-Your all-in-one
                                hub for
                                smooth operations- track,manage, and stay ahead with ease.Fully integrated into the OG
                                portal,this powerful ensuring that each team member is supported and empowered to
                                provide the best care for
                                tool keeps you connected to everything that matters, empowering you to monitor
                                activities,coordinate tasks, and
                                make informed decisions with ease.Administration has never been this seamless,smart and
                                impactful.
                            </p>
                        </article>
                        <picture style="margin-left: auto;">
                            <img src="./assets/img/recruitmentbannerimage.png" style="width: 90%;"
                                alt="recruitmentbannerimage">
                        </picture>
                    </div>
                </div>
                <div class="bottomdivisions" style="column-gap: .5rem ; grid-template-columns: 1fr ;">
                    <div class="leftcolmns" style="align-content: flex-start; row-gap: .5rem;column-gap: .5rem">
                        <div class="leftcolmns-top" style="grid-template-columns: repeat(3, 1fr);column-gap: .5rem;">

                            <div class="clmnbox" style="height: 26rem;">
                                <div class="title">
                                    <h4>
                                        Recent Admissions
                                    </h4>
                                    <button class="btndark" title="Click to view all admissions"
                                        (click)="Redircttoadmissionpage()">

                                        View all
                                    </button>
                                </div>
                                <div class="todoclmn2">
                                    <article>
                                        <ul class="bold" style="grid-template-columns:1fr 5rem 12rem 10rem">
                                            <li>
                                                Name
                                            </li>
                                            <li>
                                                Age
                                            </li>
                                            <li>
                                                Date
                                            </li>
                                            <li>
                                                Division
                                            </li>
                                        </ul>
                                        <ul style="grid-template-columns: 1fr 5rem 12rem 10rem"
                                            *ngFor="let item of admissionlist">
                                            <li class="mcfprofile">
                                                <img src="./assets/img/avatar.png" alt="">
                                                <p>
                                                    {{item.name}}
                                                </p>
                                            </li>
                                            <li>
                                                {{item.age}}
                                            </li>
                                            <li>
                                                {{item.gstibo_date_of_admission| date : 'MM-dd-yy'}}
                                            </li>
                                            <li>
                                                {{item.gstibo_division}}
                                            </li>
                                        </ul>

                                    </article>

                                </div>
                            </div>


                            <div class="clmnbox" style="height: 26rem;">

                                <app-dashboard-todo-list-alt [data]="'MCF'"></app-dashboard-todo-list-alt>

                            </div>
                            <div class="clmnbox" style="height: 26rem;">
                                <app-dashboard-assessment-calender></app-dashboard-assessment-calender>

                            </div>
                        </div>
                        <div class="leftcolmns-bottom"
                            style="grid-template-columns: minmax(auto, 35rem) 1fr minmax(auto, 30rem); column-gap: .5rem;">
                            <div class="clmnbox" style="height: auto !important;">
                                <app-dashboard-birthday-anniversary></app-dashboard-birthday-anniversary>

                            </div>
                            <div class="clmnbox" style="height: auto !important;">
                                <app-dashboard-inventory-master></app-dashboard-inventory-master>
                            </div>
                            <div class="clmnbox" style="height: auto !important;">
                                <app-dashboard-admission-block></app-dashboard-admission-block>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-wraper" *ngSwitchCase="'T13'">
            <div class="newjtsdbhrm">
                <div class="slidercolm">
                    <article>
                        <h3>
                            HR Management Dashboard
                        </h3>
                        To us, an HR Manager is the go-to person for all employee-related issue. This means that your HR
                        Manager
                        duties will involve
                        managing activities such as job design,recruitment,employee relations, performance management,
                        training
                        & development
                        and talent management.

                    </article>
                    <picture>
                        <img src="./assets/img/HRManagement_Theme.png" alt="">
                    </picture>
                </div>
                <div class="bottomdivisions">
                    <div class="leftcolmns">
                        <div class="leftcolmns-top" style="grid-template-columns: repeat(2,1fr);">
                            <div class="clmnbox">
                                <div class="title">
                                    <h4>
                                        Project Hours Tracked
                                    </h4>
                                    <div class="rightsideoptions">
                                        <select *ngIf="projectListData.length>0" (change)="onPrjEmplist_change($event)">
                                            <option value='{{itm.gstibo_project_id}}'
                                                *ngFor="let itm of (projectListData)"
                                                [selected]="(itm.gstibo_project_id == defaultEmpProjectId  ? true : false)">
                                                {{itm.gstibo_project_name}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div id="dealsourceChart" (click)="navigatePage()">
                                    <app-chart-controls [chartForm]="chartForm1"></app-chart-controls>
                                </div>
                                <!-- <div class="datagridone">
                                
                                <app-user-timesheet-status-dashboard
                                    [data]="timesheetweek"></app-user-timesheet-status-dashboard>
                            </div> -->
                            </div>
                            <div class="clmnbox ">
                                <div class="title">
                                    <h4>
                                        Timesheet / Time Off Status
                                    </h4>
                                    <div class="rightsideoptions">
                                        <select name="" id="" (change)="ontimesheetweekchange($event)">
                                            <option value='{{itm.id}}' *ngFor="let itm of (Weekoptiontype)"
                                                [selected]="(itm.id == '0')">{{itm.name}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="datagridone">
                                   <app-user-timesheet-status-dashboard [data]="timesheetweek"></app-user-timesheet-status-dashboard>
                                </div>
                                <!-- <app-dashboard-absent-employee>
                            </app-dashboard-absent-employee> -->
                            </div>
                        </div>
                        <div class="leftcolmns-bottom">
                            <div class="clmnbox">
                                <app-dashboard-absent-employee>
                                </app-dashboard-absent-employee>
                                <!-- <div class="title">
                                <h4>
                                    Time Off details <small>- Past 6 months</small>
                                </h4>
                            </div>
                            <div id="columnchart_material">
                                <app-chart-controls [chartForm]="chartForm3"></app-chart-controls>
                            </div> -->

                            </div>
                            <div class="clmnbox">
                                <app-dashboard-todo-list-alt [data]="'HRJUSA'"></app-dashboard-todo-list-alt>

                            </div>
                        </div>
                    </div>
                    <div style="display: grid;  row-gap: 1.5rem;">
                        <div class="clmnbox">
                            <div class="title">
                                <h4>
                                    Scheduled meeting
                                </h4>
                                <!-- <button class="newiconlink red" title="Click to Schedule Meeting"
                                    (click)="redirecttomeeting();">
                                    <svg>
                                        <use xlink:href="./assets/img/sprite.svg#zoom"></use>
                                    </svg>
                                </button> -->
                            </div>
                            <div class="colmcontent">
                                <div style="height: 17rem; overflow-y:auto" *ngIf="MeetingList.length>0">
                                    <ul class="newmeetings">
                                        <li *ngFor="let item of MeetingList">
                                            <span>

                                                <strong>Schedule By: {{item.Hostby}}</strong>

                                                <p>
                                                    {{item.Topic}} - {{item.StartTime}}
                                                </p>
                                            </span>
                                            <a href="{{item.JoinUrl}}" target="_blank">
                                                <button class="btndark" title="Click to open link">
                                                    Click here
                                                </button>

                                            </a>

                                        </li>
                                    </ul>
                                </div>
                            </div>

                        </div>
                        <div class="clmnbox">
                            <app-dashboard-birthday-anniversary></app-dashboard-birthday-anniversary>
                        </div>
                    </div>
                </div>
                <footer *ngIf="isNotLoading" class="center-footer">
                    <p [innerHtml]="labelMessages.copyright.copyright_message"></p>
                </footer>
            </div>
        </div>
        <div class="content-wraper" *ngSwitchCase="'T14'">
            <div class="newjtsdbrcrt">
                <div style="padding: 1.5rem 2rem 1rem 2rem; ">
                    <div class="slidercolm"
                        style="background-image:'url(./assets/img/procurementbannerbg.jpg)';overflow: hidden; border-radius: 2rem; align-content: flex-end; display: grid; grid-template-columns: auto minmax(auto, 20rem); column-gap: 1.5rem; background-size:cover; background-position: right center; align-items: center;">
                        <article>
                            <h2 style="margin-bottom: 1rem; font-size:2.5rem; font-weight:900; color: #172B4C;">
                                Recruitment Dashboard
                            </h2>
                            <p style="font-size:1.4rem;">
                                Revolutionize your recruitment game our all-new Recruitment Dashboard, the ultimate hub
                                of
                                talent acquisition brilliance right at your fingertips! Seamlessly integrated into our
                                OG portal,this gamechanging tool empowers you to navigate the hiring process with
                                unparalleled ease and precision. From visualizing candidate pipelines to monitoring job
                                openings, our dynamic dashboard provides real -time insights to fuel your recruitment
                                success.
                                With its sleek design and intuitive interface, managing talent has never been this
                                captivating.
                            </p>
                        </article>
                        <picture style="margin-left: auto;">
                            <img src="./assets/img/recruitmentbannerimage.png" style="width: 90%;"
                                alt="recruitmentbannerimage">
                        </picture>
                    </div>
                </div>
                <div class="bottomdivisions">
                    <div class="leftcolmns">
                        <div class="leftcolmns-top">
                            <div class="clmnbox">
                                <div class="title">
                                    <h4 class="titleBold">
                                        Open Requisition By Dept.
                                    </h4>

                                </div>
                                <div id="dealsourceChart" style="min-height: 21rem;">
                                    <app-chart-controls [chartForm]="chartForm1"></app-chart-controls>
                                </div>

                            </div>
                            <div class="clmnbox ">
                                <app-recdashboard-pipeline-efficency-data>
                                </app-recdashboard-pipeline-efficency-data>
                            </div>
                        </div>
                        <div style="display: grid; grid-template-columns: repeat(3,1fr); column-gap: 1rem;">
                            <div class="clmnbox">
                                <div class="title">
                                    <h4 class="titleBold">
                                        Outlook
                                    </h4>
                                    <div style="display: inline-flex; column-gap: .5rem; margin-left: auto;">
                                        <button *ngIf="!msAuthService.authenticated" (click)="signInOutlook()"
                                            style="cursor: pointer;" class="bgcolor_01"
                                            title="Sign In Microsoft Account">
                                            LogIn
                                        </button>
                                        <button *ngIf="msAuthService.authenticated" (click)="signOutOutlook()"
                                            style="cursor: pointer;" class="bgcolor_01"
                                            title="Logout from Microsoft Account">
                                            Logout
                                        </button>
                                        <button class="btndark" title="Click to view all outlook" (click)="viewemail()">

                                            View all
                                        </button>
                                    </div>
                                </div>

                                <div style="height: 17rem;">
                                    <div class="main-list " *ngIf="msAuthService.authenticated">
                                        <div class="outlookmodal-main">
                                            <div class="outlookmodalcontent">
                                                <div *ngFor="let mainmail of groupmail">
                                                    <ng-container>
                                                        <ul *ngFor="let submail of mainmail.mails">
                                                            <li>
                                                                <div class="mail-item"
                                                                    (click)="loadMessage('' + submail.id + '')">
                                                                    <div class="mail-from" style="font-weight: 700;">
                                                                        {{submail.From}}</div>
                                                                    <div class="mailSubRow">
                                                                        <div class="mail-sub mail-item-bottom ellipsis quarter-ellipsis2"
                                                                            title="{{submail.Subject}}">
                                                                            {{submail.Subject}}
                                                                        </div>
                                                                        <div class="mail-lst-dt">
                                                                            {{convertTimeToLocal(submail.Recevied)}}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </ng-container>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="clmnbox">
                               <app-dashboard-todo-list-alt [data]="'CONTACTS'"></app-dashboard-todo-list-alt>

                            </div>
                            <div class="clmnbox">
                                <app-recdashboard-newhiring-bysource></app-recdashboard-newhiring-bysource>
                            </div>
                        </div>
                    </div>
                    <div class="clmnbox" style="height: 47.5rem;">
                        <div class="title">
                            <h4 class="titleBold">
                                Offer Accepted / Declined
                            </h4>
                        </div>
                        <div class="colmcontent">
                            <div style="max-height: 45rem;">
                                <div class="todoclmn3"
                                    style="margin: 0.5rem; border: solid 1px #dbdbec; border-radius: 6px;">
                                    <article>
                                        <div style="max-height: 44rem; overflow-y: auto;">
                                            <ul class="bold"
                                                style="grid-template-columns:1fr repeat(2, 6.5rem ); font-weight: 600; color: #101218;font-size: 1.41rem;">
                                                <li>
                                                    Department
                                                </li>
                                                <li>
                                                    Accepted
                                                </li>
                                                <li>
                                                    Declined
                                                </li>
                                            </ul>
                                            <ul *ngFor="let item of offerDecline"
                                                style="grid-template-columns:1fr repeat(2, 6.5rem )">
                                                <li class="quarter-ellipsis2" title="{{item.gstibo_item}}">
                                                    {{item.gstibo_item}}
                                                </li>
                                                <li>
                                                    {{item.gstibo_value}}
                                                </li>
                                                <li>
                                                    {{item.gstibo_per}}
                                                </li>
                                            </ul>
                                        </div>
                                    </article>
                                    <!-- <p> {{od.gstibo_item}} <span>{{od.gstibo_value}}</span><span>{{od.gstibo_per}}</span></p> -->
                                    <!-- <div class="thinprogress">
                                    <div [className]="item.color" [style.width.%]="item.gstibo_per"></div>
                                </div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <footer *ngIf="isNotLoading" class="center-footer">
                    <p [innerHtml]="labelMessages.copyright.copyright_message"></p>
                </footer>
            </div>
        </div>
        <div class="content-wraper" *ngSwitchCase="'T15'">
            <div class="newjtsdbrcrt">

                <div style="padding: 1.5rem 2rem 1rem 2rem; ">
                    <div class="slidercolm"
                        style="background-image:'url(./assets/img/procurementbannerbg.jpg)';overflow: hidden; border-radius: 2rem; align-content: flex-end; display: grid; grid-template-columns: auto minmax(auto, 19rem); column-gap: 0rem; background-size:cover; background-position: right center; align-items: center;">
                        <article>
                            <h2 style="margin-bottom: 1rem; font-size:2.5rem; font-weight:900; color: #172B4C;">
                                Procurement Dashboard
                            </h2>
                            <p style="font-size:1.4rem;">
                                Welcome to the Procurement Dashboard, your gateway to untapped potential and boundless
                                growth in
                                our
                                portal! Dive into a world of opportunity as you navigate our dynamic dashboard,
                                meticulously
                                designed to
                                supercharge your sales pipeline, and maximize revenue generation. Seamlessly integrated
                                into our
                                platform, this intuitive dashboard empowers you to visualize, track, and capitalize on
                                every
                                lead
                                and
                                opportunity with precision and ease. From real-time insights to actionable analytics,
                                our
                                innovative
                                tools provide the strategic edge you need to stay ahead of the competition
                            </p>

                        </article>
                        <picture style="margin-left: auto;">
                            <img src="./assets/img/procurementbannerimage.png" style="width: 100%;"
                                alt="procurementbannerimage">
                        </picture>
                    </div>
                </div>
                <div class="bottomdivisions" style="grid-template-columns: 1fr; padding: 0 2rem;">
                    <div class="leftcolmns" style="grid-template-columns: 1.5fr 1fr 1fr;column-gap: 1rem;">
                        <div class="clmnbox">
                            <app-dashboard-opprunity-revenueclosed></app-dashboard-opprunity-revenueclosed>
                        </div>
                        <div class="clmnbox">
                            <app-dashboard-opportunity-status></app-dashboard-opportunity-status>
                        </div>
                        <div class="clmnbox">
                            <div class="title">
                                <h4 class="titleBold">
                                    Top 10 Opportunity Status
                                </h4>

                            </div>
                            <div class="todoclmn3"
                                style="min-height: 18rem; margin: 0.5rem; border: solid 1px #dbdbec; border-radius: 6px;">
                                <article>
                                    <div style="max-height: 18rem; overflow-y: auto;">
                                        <ul class="thead bold"
                                            style="background-color: #ededf5; margin-top: 0px; font-weight: 600; color: #404040;">
                                            <li>
                                                OP-ID
                                            </li>

                                            <li>
                                                Agency
                                            </li>
                                            <li>
                                                Status
                                            </li>
                                        </ul>
                                        <ul *ngFor="let item of top10Opportunity">
                                            <li style="min-height: 3rem;">
                                                {{item.gstibo_opportunity_Id}}
                                            </li>
                                            <li class="quarter-ellipsis2" title="{{item.gstibo_agency}}">
                                                {{item.gstibo_agency}}
                                            </li>
                                            <li class="quarter-ellipsis2" title="{{item.gstibo_status}}">
                                                {{item.gstibo_status}}
                                            </li>
                                        </ul>
                                    </div>
                                </article>
                            </div>
                        </div>
                    </div>
                    <div class="leftcolmns"
                        style="grid-template-columns: 1fr 1.5fr 1fr;column-gap: 1rem;margin-top: .75rem;">
                        <!-- <div class="clmnbox ">
                            <div class="title">
                                <h4>
                                    Opportunity Funnel
                                </h4>
                                <div class="rightsideoptions">
                                    <select class="form-control" style="width:85px;" *ngIf="Quarterdata.length>0"
                                        (change)="onopportunityfunnelchange($event)">
                                        <option value='{{itm.id}}' *ngFor="let itm of (Quarterdata)"
                                            [selected]="(itm.id == funnelquarter)">{{itm.name}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div id="projectChart" style="height:18rem; width: 100%;">
                                <div *ngIf="funnelchart.length==0" style="text-align: center;padding:20px;"> No data
                                    found</div>
                                <app-chart-controls [chartForm]="chartForm2"
                                    *ngIf="funnelchart.length>0"></app-chart-controls>
                            </div>
                        </div> -->
                        <!-- <div class="clmnbox">
                            <div class="title">
                                <h4>
                                    Win Ratio
                                </h4>
                                <div class="rightsideoptions">
                                    <select class="form-control" style="width:85px;"
                                        *ngIf="winRatioQuarterData?.length > 0"
                                        (change)="onWinQuarterChange($event)">
                                        <option value='{{item.id}}' *ngFor="let item of (winRatioQuarterData)"
                                            [selected]="(item.id == winQuarter)">
                                            {{item.name}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div id="stackedbar_chart" style="height: 16rem;">
                                <div *ngIf="winRatioChart?.length==0" style="text-align: center;padding:20px;">
                                    No data found
                                </div>
                                <app-chart-controls [chartForm]="chartForm5"></app-chart-controls>
                            </div>
                        </div> -->
                        <div class="clmnbox">
                            <div class="title">
                                <h4 class="titleBold">
                                    Outlook
                                </h4>
                                <div style="display: inline-flex; column-gap: .5rem; margin-left: auto;">
                                    <button *ngIf="!msAuthService.authenticated" (click)="signInOutlook()"
                                        style="cursor: pointer; background-color:#1E8AF3;"
                                        title="Sign In Microsoft Account">
                                        LogIn
                                    </button>
                                    <button *ngIf="msAuthService.authenticated" (click)="signOutOutlook()"
                                        style="cursor: pointer; background-color: #10172A;"
                                        title="Logout from Microsoft Account">
                                        Logout
                                    </button>
                                    <button style="cursor: pointer; background-color: #10172A;"
                                        title="Click to view all outlook" (click)="viewemail()">

                                        View all
                                    </button>
                                </div>
                            </div>

                            <div style="height: 20rem;">
                                <div class="main-list " *ngIf="msAuthService.authenticated">
                                    <div class="outlookmodal-main">
                                        <div class="outlookmodalcontent">
                                            <div *ngFor="let mainmail of groupmail">
                                                <ng-container>
                                                    <ul *ngFor="let submail of mainmail.mails">
                                                        <li>
                                                            <div class="mail-item"
                                                                (click)="loadMessage('' + submail.id + '')">
                                                                <div class="mail-from" style="font-weight: 700;">
                                                                    {{submail.From}}</div>
                                                                <div class="mailSubRow">
                                                                    <div class="mail-sub mail-item-bottom ellipsis quarter-ellipsis2"
                                                                        title="{{submail.Subject}}">
                                                                        {{submail.Subject}}
                                                                    </div>
                                                                    <div class="mail-lst-dt">
                                                                        {{convertTimeToLocal(submail.Recevied)}}</div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="clmnbox">
                            <app-dashboard-opprunity-campaigntype></app-dashboard-opprunity-campaigntype>
                        </div>
                        <div class="clmnbox">
                            <app-dashboard-todo-list-alt [data]="'HR'"></app-dashboard-todo-list-alt>
                        </div>
                    </div>
                </div>
                <footer *ngIf="isNotLoading" class="center-footer">
                    <p [innerHtml]="labelMessages.copyright.copyright_message"></p>
                </footer>
            </div>
        </div>

        <div class="content-wraper" *ngSwitchCase="'T16'">
            <div class="newjtsdbrcrt">
                <div class="slidercolm" style="grid-template-columns: 1fr 30rem;">
                    <article>
                        <h3>
                            CRM Dashboard
                        </h3>

                        Seamlessly track each lead's journey from inception to conversion, ensuring no opportunity falls
                        through the cracks. CRM solution empowers team to efficiently navigate every stage of the lead
                        lifecycle. With intuitive features, you can streamline lead acquisition, nurture relationships,
                        and
                        drive conversions with ease. Stay organized, stay connected, and stay ahead of the competition
                        with
                        the comprehensive CRM platform.

                    </article>
                    <picture style="padding: 0;">
                        <img style="max-height: 17.5rem;" src="./assets/img/Recruitment_Theme.png" alt="">
                    </picture>
                </div>
                <div class="bottomdivisions">
                    <div class="leftcolmns">
                        <div class="leftcolmns-top" style="grid-template-columns: 1fr minmax(auto, 44rem);">
                            <div class="clmnbox">
                                <div class="title">
                                    <h4>
                                        {{dashboardTemplateForm.value.crmCB1Title}}
                                    </h4>

                                </div>
                                <div style="padding: 0 1rem; height: 19rem; overflow-y: auto;">
                                    <ng-container *ngFor="let dp of dealsProgress;">
                                        <div class="orangebars">
                                            <p>{{dp.value}} {{dp.item}} <span>{{dp.value}}</span></p>
                                            <!-- {{dp.perc}}[style.width]="dp.perc" -->
                                            <div class="thinprogress">

                                                <div class="bars" [style.background-color]="dp.colors"
                                                    [style.width]="dp.per"></div>
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>

                            </div>
                            <div class="clmnbox ">
                                <div class="title">
                                    <h4>{{dashboardTemplateForm.value.crmCB3Title}}</h4>
                                </div>
                                <div class="todoclmn3">
                                    <article style="overflow: auto;height:18rem;">
                                        <ul class="bold">
                                            <li>
                                                &nbsp;
                                            </li>

                                            <li>
                                                Deals Won
                                            </li>
                                            <li>
                                                Deals Open
                                            </li>

                                            <li>
                                                Deals Lost
                                            </li>
                                        </ul>
                                        <ul *ngFor="let dp of dealsPivote">
                                            <li>
                                                {{dp.gstibo_item}}
                                            </li>
                                            <li>
                                                {{dp.gstibo_won_value}} <span
                                                    [class]="dp.gstibo_won_color">{{dp.gstibo_won_per}}</span>
                                            </li>
                                            <li>
                                                {{dp.gstibo_open_value}} <span
                                                    [class]="dp.gstibo_open_color">{{dp.gstibo_open_per}}</span>
                                            </li>
                                            <li>
                                                {{dp.gstibo_lost_value}} <span
                                                    [class]="dp.gstibo_lost_color">{{dp.gstibo_lost_per}}</span>
                                            </li>
                                        </ul>
                                    </article>
                                </div>
                                <!-- <table class="dashboard_table">
                                <thead>
                                    <tr>
                                        <th scope="col"> &nbsp; </th>
                                        <th scope="col">Deals Won</th>
                                        <th scope="col">Deals Open</th>
                                        <th scope="col">Deals Lost</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container *ngFor="let dp of dealsPivote;">
                                        <tr>
                                            <th scope="row">{{dp.gstibo_item}}</th>
                                            <td>{{dp.gstibo_won_value}} <span
                                                    [class]="dp.gstibo_won_color">{{dp.gstibo_won_per}}</span></td>
                                            <td>{{dp.gstibo_open_value}} <span
                                                    [class]="dp.gstibo_open_color">{{dp.gstibo_open_per}}</span></td>
                                            <td>{{dp.gstibo_lost_value}} <span
                                                    [class]="dp.gstibo_lost_color">{{dp.gstibo_lost_per}}</span></td>
                                        </tr>
                                    </ng-container>
                                </tbody>
                            </table> -->
                            </div>
                        </div>
                        <div class="leftcolmns-bottom">
                            <div class="clmnbox">
                                <div class="title">
                                    <h4>{{dashboardTemplateForm.value.crmCB2Title}}</h4>
                                </div>
                                <div id="columnchart_values">
                                    <app-chart-controls [chartForm]="chartForm2"></app-chart-controls>
                                </div>


                            </div>
                            <div class="clmnbox">
                                <div class="title">
                                    <h4>{{dashboardTemplateForm.value.crmCB4Title}}</h4>

                                </div>
                                <div *ngIf="leadConversation[0]" class="coloredbar" style="padding: 0 1rem;">
                                    <div class="thik_progress red">
                                        {{leadConversation[0].gstibo_created_value}}
                                    </div>
                                    <p>{{leadConversation[0].gstibo_created_per}}%</p>
                                    <div class="thik_progress orange">
                                        {{leadConversation[0].gstibo_converted_value}}
                                    </div>
                                    <p>{{leadConversation[0].gstibo_converted_per}}%</p>
                                    <div class="thik_progress green">
                                        {{leadConversation[0].gstibo_won_value}}
                                    </div>
                                    <p>{{leadConversation[0].gstibo_won_per}}%</p>
                                    <div class="thik_progress blue">
                                        {{leadConversation[0].gstibo_lost_value}}
                                    </div>
                                    <p>{{leadConversation[0].gstibo_lost_per}}%</p>
                                </div>
                                <div class="colorbullet">
                                    <p><span class="red"></span>Leads Created</p>
                                    <p><span class="orange"></span>Leads Converted</p>
                                    <p><span class="green"></span>Leads Won</p>
                                    <p><span class="blue"></span>Leads Lost</p>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="clmnbox">
                        <div class="title">
                            <h4>
                                {{dashboardTemplateForm.value.SB1Title}}
                            </h4>
                        </div>
                        <div class="colmcontent">
                            <div style="max-height: 27rem;">
                                <ng-container *ngFor="let dl of top5Deals;">
                                    <div class="dealings">
                                        <div class="titls">
                                            <div class="number">{{dl.gstibo_id}}</div>
                                            <h4>{{dl.gstibo_name}}
                                                <span>${{dl.gstibo_value}}</span>
                                            </h4>
                                        </div>
                                        <p><strong>Salse Rep:</strong> {{dl.gstibo_salesrep}}</p>
                                        <p><strong> Sales Cycle Length:</strong> {{dl.gstibo_days}} days</p>
                                    </div>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
                <footer *ngIf="isNotLoading" class="center-footer">
                    <p [innerHtml]="labelMessages.copyright.copyright_message"></p>
                </footer>
            </div>
        </div>

        <div class="ogNewraper" *ngSwitchCase="'T17'">
            <aside class="newSidebar">
                <picture class="sidelogo">
                    <img src="assets/img/Jtsi_vendor_logo.png" alt="">
                </picture>
                <h4 class="menutitle">
                    Menu
                </h4>
                <nav class="ogNewNav" role="navigation">
                    <ul class="ogNewNav__list">
                        <li>
                            <a href="javascript:;" (click)="vendoroverview()">
                                <svg>
                                    <use [attr.xlink:href]="srcPath.overviewIcon"></use>
                                </svg>

                                Overview
                            </a>
                        </li>
                        <li>
                            <a href="javascript:;" (click)="vendorDetails()">
                                <svg>
                                    <use [attr.xlink:href]="srcPath.vendordetailsIcon"></use>
                                </svg>

                                Vendor Details
                            </a>
                        </li>
                        <li>
                            <a href="javascript:;" (click)="vendorhelpdesk()">
                                <svg>
                                    <use [attr.xlink:href]="srcPath.helpdeskIcon"></use>
                                </svg>

                                Help Desk
                            </a>
                            <!-- <input id="mnuitm1" type="checkbox" hidden />
                            <label for="mnuitm1">
                                <svg>
                                    <use [attr.xlink:href]="srcPath.helpdeskIcon"></use>
                                </svg>
                                Help Desk
                            </label>
                            <ul class="group-list">
                                <li><a href="javascript:;">1st level item</a></li>                               
                            </ul> -->
                        </li>
                        <li>
                            <input id="mnuitm2" type="checkbox" hidden />
                            <label for="mnuitm2">
                                <svg>
                                    <use [attr.xlink:href]="srcPath.reportsIcon"></use>
                                </svg>
                                Reports
                            </label>
                            <ul class="group-list">
                                <li><a href="javascript:;">1st level item</a></li>
                                <!-- <li>
                                    <label for="sub-group-1"><span class="fa fa-angle-right"></span> Second
                                        level</label>
                                </li> -->
                            </ul>
                        </li>
                    </ul>
                </nav>
                <h4 class="menutitle">
                    General
                </h4>
                <nav class="ogNewNav" role="navigation">
                    <ul class="ogNewNav__list">
                        <li>
                            <a href="javascript:;" routerLink="{{routerPath.home}}{{routerPath.viewProfile}}">
                                <svg>
                                    <use [attr.xlink:href]="srcPath.profileIcon"></use>
                                </svg>

                                Profile
                            </a>
                        </li>
                        <li>
                            <a href="javascript:;">
                                <svg>
                                    <use [attr.xlink:href]="srcPath.settingsIcon"></use>
                                </svg>

                                Settings
                            </a>
                        </li>
                        <li>
                            <a href="javascript:;">
                                <svg>
                                    <use [attr.xlink:href]="srcPath.messageIcon"></use>
                                </svg>

                                Message
                            </a>
                        </li>
                        <li>
                            <a href="javascript:;">
                                <svg>
                                    <use [attr.xlink:href]="srcPath.securityIcon"></use>
                                </svg>

                                Security
                            </a>
                        </li>
                        <li>
                            <a href="javascript:;" (click)="signOut()">
                                <svg>
                                    <use [attr.xlink:href]="srcPath.newLogoutIcon"></use>
                                </svg>

                                Logout
                            </a>
                        </li>
                    </ul>
                </nav>
            </aside>
            <div class="contentSide">
                <header class="ogNewHeader">
                    <h1>
                        Vendor Dashboard
                    </h1>
                    <div class="headeroptions">
                        <div class="headersearch">
                            <input type="search" name="" id="">
                            <button type="button">
                                <svg>
                                    <use [attr.xlink:href]="srcPath.newSearchIcon"></use>
                                </svg>
                            </button>
                        </div>
                        <button class="roundbtn" type="button">
                            <svg>
                                <use [attr.xlink:href]="srcPath.reportIcon"></use>
                            </svg>
                        </button>
                        <button class="roundbtn" type="button">
                            <svg>
                                <use [attr.xlink:href]="srcPath.notificationIcon"></use>
                            </svg>
                        </button>
                        <div class="userpropic">
                            <figure>
                                <img src="assets/img/contract_03.jpg" alt="">
                            </figure>
                            <figcaption>
                                {{vendorName}}
                            </figcaption>
                            <ul>
                                <li>
                                    <!-- <a href="javascript:;">User Profile</a> -->
                                    <a class="profile" routerLink="{{routerPath.home}}{{routerPath.viewProfile}}">User
                                        Profile</a>
                                </li>
                                <li>
                                    <a href="javascript:;" (click)="changepassword()">Change Password</a>
                                </li>
                                <li>
                                    <a href="javascript:;" (click)="signOut()">Logout</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </header>
                <div class="vendordb">
                    <div class="dbleft">
                        <div class="rainbowbanner">
                            <article>
                                <h3>
                                    Hello, {{vendorName}}
                                </h3>
                                <p>
                                    We're glad to have you on board!
                                </p>
                                <p>
                                    Here, you can manage your orders, track payments, update your profile,<br>
                                    and stay connected with <strong>JTSi. </strong>
                                    <a class="btns orange" href="javascript:;" (click)="vendoradshboardclick()">Click
                                        Here</a>
                                </p>
                                <p>

                                </p>
                            </article>
                            <picture>
                                <figure><img src="assets/img/Welcome_bg_icon.png" alt=""></figure>
                                <figcaption>
                                    Let's make business smoother together
                                </figcaption>
                            </picture>
                        </div>
                        <div class="tiles">
                            <div class="tileclm red">
                                <article>
                                    <p>
                                        Orders
                                    </p>
                                    <h2>
                                        90
                                    </h2>
                                    <h6>
                                        <span>5.33% </span> something
                                    </h6>
                                </article>
                                <svg>
                                    <use [attr.xlink:href]="srcPath.orderIcon"></use>
                                </svg>
                            </div>
                            <div class="tileclm green">
                                <article>
                                    <p>
                                        Delivered
                                    </p>
                                    <h2>
                                        83
                                    </h2>
                                    <h6>
                                        <span>5.33% </span> something
                                    </h6>
                                </article>
                                <svg>
                                    <use [attr.xlink:href]="srcPath.deliveredIcon"></use>
                                </svg>
                            </div>
                            <div class="tileclm blue">
                                <article>
                                    <p>
                                        Invoice and Payments
                                    </p>
                                    <h2>
                                        76
                                    </h2>
                                    <h6>
                                        <span>5.33% </span> something
                                    </h6>
                                </article>
                                <svg>
                                    <use [attr.xlink:href]="srcPath.invoiceIcon"></use>
                                </svg>
                            </div>
                        </div>
                        <div class="bttmgrid">
                            <div class="btmclm">
                                <div class="boxtitle">
                                    <h4>
                                        Recent Activities
                                    </h4>
                                </div>
                                <table class="zebratable">
                                    <tr>
                                        <th>Opportunity ID</th>
                                        <th>Date</th>
                                        <th>Title</th>
                                        <th>Solicitation</th>
                                        <th>Organization</th>
                                        <th>Agency</th>
                                    </tr>
                                    <tr *ngFor="let item of vendorOpportunityList">
                                        <td>{{item.gstibo_opportunity_id}}</td>
                                        <td>{{item.gstibo_created_date | date : 'MM/dd/yyyy'}}</td>
                                        <td>
                                            {{item.gstibo_title}}
                                        </td>
                                        <td>{{item.gstibo_solicitation}}</td>
                                        <td>{{item.gstibo_organization}}</td>
                                        <td>{{item.gstibo_agency}}</td>
                                    </tr>
                                </table>
                            </div>
                            <!-- <div class="btmclm">
                                <div class="boxtitle">
                                    <h4>
                                       <b> Recent Activities</b>
                                    </h4>
                                    <div class="rtoptions">
                                        <select class="frmselect" name="" id="">
                                            <option value="">
                                                Select
                                            </option>
                                            <option value="">
                                                Something
                                            </option>
                                            <option value="">
                                                Something else
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <table class="zebratable">
                                    <tr>
                                        <th>SL No.</th>
                                        <th>Date</th>
                                        <th>Description</th>
                                        <th>Activity Type</th>
                                        <th>Status</th>
                                        <th>Action</th>
                                    </tr>
                                    <tr>
                                        <td>Jill</td>
                                        <td>20-02-2025</td>
                                        <td>
                                            Ncidunt deserunt perferendis officiis aspernatur error ullam exercitationem
                                            laboriosam!
                                        </td>
                                        <td>Jill</td>
                                        <td>Smith</td>
                                        <td>50</td>
                                    </tr>
                                    <tr>
                                        <td>Jill</td>
                                        <td>20-02-2025</td>
                                        <td>
                                            Ncidunt deserunt perferendis officiis aspernatur error ullam exercitationem
                                            laboriosam!
                                        </td>
                                        <td>Jill</td>
                                        <td>Smith</td>
                                        <td>50</td>
                                    </tr>
                                    <tr>
                                        <td>Jill</td>
                                        <td>20-02-2025</td>
                                        <td>
                                            Ncidunt deserunt perferendis officiis aspernatur error ullam exercitationem
                                            laboriosam!
                                        </td>
                                        <td>Jill</td>
                                        <td>Smith</td>
                                        <td>50</td>
                                    </tr>
                                    <tr>
                                        <td>Jill</td>
                                        <td>20-02-2025</td>
                                        <td>
                                            Ncidunt deserunt perferendis officiis aspernatur error ullam exercitationem
                                            laboriosam!
                                        </td>
                                        <td>Jill</td>
                                        <td>Smith</td>
                                        <td>50</td>
                                    </tr>
                                </table>
                            </div> -->
                            <div class="btmclm">
                                <div class="boxtitle">
                                    <h4>
                                        Last Orders
                                    </h4>
                                    <div class="rtoptions">
                                        <button class="linkbtn">
                                            View All
                                        </button>
                                    </div>
                                </div>
                                <div class="colorlist">
                                    <ul class="listorder">
                                        <li>
                                            <svg>
                                                <use [attr.xlink:href]="srcPath.productIcon"></use>
                                            </svg>
                                        </li>
                                        <li>
                                            Product name
                                            <small>
                                                Order number
                                                <strong>
                                                    1234567890
                                                </strong>
                                            </small>
                                        </li>
                                        <li>
                                            $238
                                            <abbr class="processing" title="status">processing</abbr>
                                        </li>
                                    </ul>
                                    <ul class="listorder">
                                        <li>
                                            <svg>
                                                <use [attr.xlink:href]="srcPath.productIcon"></use>
                                            </svg>
                                        </li>
                                        <li>
                                            Product name
                                            <small>
                                                Order number
                                                <strong>
                                                    1234567890
                                                </strong>
                                            </small>
                                        </li>
                                        <li>
                                            $238
                                            <abbr class="pending" title="status">Pending</abbr>
                                        </li>
                                    </ul>
                                    <ul class="listorder">
                                        <li>
                                            <svg>
                                                <use [attr.xlink:href]="srcPath.productIcon"></use>
                                            </svg>
                                        </li>
                                        <li>
                                            Product name
                                            <small>
                                                Order number
                                                <strong>
                                                    1234567890
                                                </strong>
                                            </small>
                                        </li>
                                        <li>
                                            $238
                                            <abbr class="active" title="status">New Order</abbr>
                                        </li>
                                    </ul>
                                    <ul class="listorder">
                                        <li>
                                            <svg>
                                                <use [attr.xlink:href]="srcPath.productIcon"></use>
                                            </svg>
                                        </li>
                                        <li>
                                            Product name
                                            <small>
                                                Order number
                                                <strong>
                                                    1234567890
                                                </strong>
                                            </small>
                                        </li>
                                        <li>
                                            $238
                                            <abbr class="active" title="status">New Order</abbr>
                                        </li>
                                    </ul>
                                    <ul class="listorder">
                                        <li>
                                            <svg>
                                                <use [attr.xlink:href]="srcPath.productIcon"></use>
                                            </svg>
                                        </li>
                                        <li>
                                            Product name
                                            <small>
                                                Order number
                                                <strong>
                                                    1234567890
                                                </strong>
                                            </small>
                                        </li>
                                        <li>
                                            $238
                                            <abbr class="active" title="status">New Order</abbr>
                                        </li>
                                    </ul>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="dbright">
                        <div class="rgtclm">
                            <div class="boxtitle txtcntr">
                                <h4>
                                    Reviews
                                </h4>
                            </div>
                            <!-- <div id="donutchart" style="width: 200px; height: 200px; margin:auto ;"></div> -->
                            <app-chart-controls [chartForm]="chartForm2"></app-chart-controls>
                        </div>
                        <!-- <div class="rgtclm">
                            <div class="boxtitle">
                                <h4>
                                  <b>  Payment Request</b>
                                </h4>
                            </div>
                            <div class="rightlist">
                                <ul class="recentlist">
                                    <li>
                                        <svg>
                                            <use [attr.xlink:href]="srcPath.payreqstIcon"></use>
                                        </svg>
                                        <span>
                                            Payment Request
                                            <small>
                                                Date: 10 12 2025
                                            </small>
                                        </span>
                                    </li>
                                    <li>
                                        <svg>
                                            <use [attr.xlink:href]="srcPath.payreqstIcon"></use>
                                        </svg>
                                        <span>
                                            Payment Request
                                            <small>
                                                Date: 10 12 2025
                                            </small>
                                        </span>
                                    </li>
                                    <li>
                                        <svg>
                                            <use [attr.xlink:href]="srcPath.payreqstIcon"></use>
                                        </svg>
                                        <span>
                                            Payment Request
                                            <small>
                                                Date: 10 12 2025
                                            </small>
                                        </span>
                                    </li>
                                    <li>
                                        <svg>
                                            <use [attr.xlink:href]="srcPath.payreqstIcon"></use>
                                        </svg>
                                        <span>
                                            Payment Request
                                            <small>
                                                Date: 10 12 2025
                                            </small>
                                        </span>
                                    </li>
                                </ul>
                                <button class="grayline">
                                    View All
                                </button>
                            </div>
                        </div> -->
                        <div class="rgtclm">
                            <div class="boxtitle">
                                <h4>
                                    Teaming Agreements
                                </h4>
                            </div>
                            <div class="rightlist">
                                <ul class="recentlist " *ngFor="let item of vendorDocsList">
                                    <li class="listorder">
                                        <svg>
                                            <use [attr.xlink:href]="srcPath.payreqstIcon"></use>
                                        </svg>
                                        <span>
                                            <!-- {{ item.nf_file_name}} -->
                                            <a style="font-weight: bold;font-size: 13px; cursor: pointer !important;"
                                                (click)="viewfiles(item.nf_full_path)" href="JavaScript:void(0);">{{
                                                item.nf_file_name}} </a>
                                            <small>
                                                Date: {{item.gstibo_upload_date | date : 'MM/dd/yyyy'}}
                                            </small>
                                    <li style="margin-left: 83%;">
                                        <abbr class="pending" title="Email Status">{{item.gstibo_email_status}}</abbr>
                                    </li>
                                    </span>

                                    </li>

                                </ul>
                                <button class="grayline">
                                    View All
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div class="content-wraper" *ngSwitchCase="'T19'">
            <div class="newjtsdbrcrt">
                <div style="padding: 1.2rem 2rem .5rem 2rem; ">
                    <div class="slidercolm"
                        style="background-image:'url(./assets/img/Pg_Booking_Banner_image.png)';overflow: hidden; border-radius: 2rem; align-content: flex-end; display: grid; grid-template-columns: auto minmax(auto, 20rem); column-gap: 1.5rem; background-size:cover; background-position: right center; align-items: center;">
                        <article>
                            <h2 style="margin-bottom: 1rem; font-size:2.5rem; font-weight:900; color: #fcf9fc;">
                                Welcome to St.Mary's PG and help drive the growth of <br>Accommodation services
                            </h2>
                            <p style="font-size:1.4rem;color:#fcf9fc;">
                                St.Mary's PG is comprehensive Accommodation management System,Handling
                                Booking,<br>payment,Guest Services with ease
                            </p>
                        </article>
                        <picture style="margin-left: auto;">
                            <img src="./assets/img/Pg_Booking_Banner_svg_image.png" style="width: 90%;"
                                alt="Pg_Booking_Banner_svg_image">
                        </picture>
                    </div>
                </div>
                <div class="bottomdivisions" style="grid-template-columns: 1fr; padding: 0 2rem;">
                    <div class="leftcolmns" style="grid-template-columns: 1.3fr 1.3fr 1fr;column-gap: 1rem;">
                        <div class="clmnbox">
                            <app-pg-recent-bookings></app-pg-recent-bookings>

                        </div>
                        <div class="clmnbox">
                            <app-pg-recent-inquiries></app-pg-recent-inquiries>

                        </div>
                        <div class="clmnbox">
                            <div class="title" style="margin-bottom: 0.5rem;">
                                <h4 class="titleBold">
                                    Occupancy at a Glance
                                </h4>
                            </div>
                            <div class="todoclmn3 col3">
                                <div class="row text-center gx-1 gy-1 ">
                                    <div
                                        class="col-md-4 card shadow-sm d-flex flex-column justify-content-center align-items-center p-3">
                                        <h1 class="card-title">{{this.Occupancyglance?.totalrooms || 0}}</h1>
                                        <p class="tinytext text-muted">Total Rooms</p>
                                    </div>

                                    <div
                                        class="col-md-4 card shadow-sm d-flex flex-column justify-content-center align-items-center p-3">
                                        <h1 class="card-title">{{this.Occupancyglance?.availablerooms || 0}}
                                        </h1>
                                        <p class="tinytext text-muted">Available Rooms</p>
                                    </div>

                                    <div
                                        class="col-md-4 card shadow-sm d-flex flex-column justify-content-center align-items-center p-3">
                                        <h1 class="card-title">{{this.Occupancyglance?.occupiedrooms || 0}}</h1>
                                        <p class="tinytext text-muted">Occupied Rooms</p>
                                    </div>
                                </div>
                                <!-- <hr class="my-2 mx-auto w-75 opacity-50"> -->
                                <div class="row text-center text-center gx-1 gy-1">
                                    <div
                                        class="col-md-4 card shadow-sm d-flex flex-column justify-content-center align-items-center p-3">
                                        <h1 class="card-title">{{this.Occupancyglance?.newbooking || 0}}</h1>
                                        <p class="tinytext text-muted">New Booking</p>
                                    </div>
                                    <div
                                        class="col-md-4 card shadow-sm d-flex flex-column justify-content-center align-items-center p-3">
                                        <h1 class="card-title">{{this.Occupancyglance?.checkin || 0}}</h1>
                                        <p class="tinytext text-muted">Check-In Today</p>
                                    </div>
                                    <div
                                        class="col-md-4 card shadow-sm d-flex flex-column justify-content-center align-items-center p-3">
                                        <h1 class="card-title">{{this.Occupancyglance?.checkout || 0}}</h1>
                                        <p class="tinytext text-muted">Check-Out Today</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="leftcolmns" style="grid-template-columns: 2fr 2fr;column-gap: 1rem;margin-top: .75rem;">
                        <div class="clmnbox">
                            <app-room-status-summary></app-room-status-summary>
                        </div>
                        <!-- <div class="clmnbox">
                            <div class="title">
                                <h4 class="titleBold">
                                    Open Requisition By Dept.
                                </h4>

                            </div>
                            <div id="dealsourceChart" style="min-height: 21rem;">
                                <app-chart-controls [chartForm]="chartForm1"></app-chart-controls>
                            </div>

                        </div> -->
                        <div class="clmnbox">
                            <app-pg-latest-payment></app-pg-latest-payment>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="dd-content-wraper" *ngSwitchCase="'T20'">
            <!-- <div class="dd-title-main">
                <h1>Dashboard</h1>
                <h2>This dashboard shows key user engagement metrics to help track portal usage and performance</h2>
            </div> -->
            <div class="dd-cards-main">
                <div class="dd-card">
                    <div class="dd-card-text">
                        <h2>Weekly New Sessions</h2>
                        <h1>{{weeklyNewSession}}</h1>
                        <h3>Total count of new sessions in a week</h3>
                    </div>
                    <div class="dd-card-arrow">
                        <svg>
                            <use xlink:href="./assets/img/sprite.svg#sidewards_direction_arrow"></use>
                        </svg>
                    </div>
                </div>
                <div class="dd-card">
                    <div class="dd-card-text">
                        <h2>Page Views</h2>
                        <h1>{{viewPageCount}}</h1>
                        <h3>Total no of pages viewed in a week</h3>
                    </div>
                    <div class="dd-card-arrow">
                        <svg>
                            <use xlink:href="./assets/img/sprite.svg#sidewards_direction_arrow"></use>
                        </svg>
                    </div>
                </div>
                <div class="dd-card">
                    <div class="dd-card-text">
                        <h2>Bounce Rate</h2>
                        <h1>{{bounceRate}}%</h1>
                        <h3>Rate of sessions ended in error</h3>
                    </div>
                    <div class="dd-card-arrow">
                        <svg>
                            <use xlink:href="./assets/img/sprite.svg#sidewards_direction_arrow"></use>
                        </svg>
                    </div>
                </div>
                <div class="dd-card">
                    <div class="dd-card-text">
                        <h2>Avg. Time on Site</h2>
                        <h1>{{avgTimeOnSiteWeek}}</h1>
                        <h3>Average time spent by user in a week</h3>
                    </div>
                    <div class="dd-card-arrow">
                        <svg>
                            <use xlink:href="./assets/img/sprite.svg#sidewards_direction_arrow"></use>
                        </svg>
                    </div>
                </div>
            </div>
            <div class="dd-main">
                <div class="dd-main-inner">
                    <div class="dd-main-session">
                        <div class="summary">
                            <div class="account-summary">
                                <h3 style="font-weight: 600;">Account Summary</h3>
                                <div class="dd-main-summary-inner">
                                    <p>
                                        Created Date
                                        <span class="dd-main-summary-card-span">
                                            {{accountCreatedDate }}
                                        </span>
                                    </p>
                                    <p>
                                        Last Login Date
                                        <span class="dd-main-summary-card-span">
                                            {{lastLoginDate }}
                                        </span>
                                    </p>
                                    <!-- <p>
                                        Last Login Date
                                        <span class="dd-main-summary-card-span">
                                            16-12-2026
                                        </span>
                                    </p> -->
                                </div>
                            </div>
                            <div class="dd-announcements">
                                <div class="titleh3">
                                    <h3 style="font-weight: 600;">Announcements</h3>
                                    <div style="display: inline-flex; column-gap: .5rem; margin-left: auto;">
                                        <button *ngIf="usertype=='Admin'" type="button" style="cursor: pointer;"
                                            class="btndarkcon" title="Edit" (click)="EditAnnoucements(paraAnnounce)">
                                            {{buttonlabelAnnouce}}
                                        </button>
                                    </div>
                                </div>
                                <div [attr.contenteditable]="buttonAnnouce == 'IsEdit'?'true' :'false'"
                                    style="max-height: 5rem; " #paraAnnounce
                                    [ngClass]="buttonAnnouce == 'IsEdit'?'nowrapping':'three-line' "
                                    title="{{AnnounceText}}">{{AnnounceText}}</div>
                            </div>
                        </div>
                        <div class="activity">
                            <div class="title">
                                <h4 class="titleBold">
                                    Recent Activities
                                </h4>
                            </div>
                            <div class="todoclmn3">
                                <article class="todoclmn3-data">
                                    <ul class="todoclmn3-thead" style="padding: 0;">
                                        <li>
                                            Activity Details
                                        </li>
                                        <li style="justify-content: left !important;">
                                            Activity Type
                                        </li>
                                        <li>
                                            Activity Performed
                                        </li>
                                        <li>
                                            Updated Date
                                        </li>
                                    </ul>
                                    <div style="max-height: 14.5rem;overflow-y: auto;">
                                        <ul *ngFor="let tr of activityData">
                                            <li class="quarter-ellipsis-act" title="{{tr.auditlog}}">
                                                {{tr.auditlog}}
                                            </li>
                                            <li class="quarter-ellipsis-act">
                                                {{tr.gstibo_page_name}}
                                            </li>
                                            <li style="color: black;">
                                                {{tr.gstibo_action}}
                                            </li>
                                            <li style="color: black;">
                                                {{tr.gstibo_created_on | date : custDateFormat_date }}
                                            </li>
                                        </ul>
                                    </div>
                                </article>
                            </div>
                        </div>
                    </div>
                    <div class="dd-main-outlook-todo-con-default ">
                        <div class="dd-main-outlook clmnbox">
                            <div class="title">
                                <h4 class="titleBold">
                                    Outlook
                                </h4>
                                <div style="display: inline-flex; column-gap: .5rem; margin-left: auto;">
                                    <button *ngIf="!msAuthService.authenticated" (click)="signInOutlook()"
                                        style="cursor: pointer;" class="bgcolor_01" title="Sign In Microsoft Account">
                                        LogIn
                                    </button>
                                    <button *ngIf="msAuthService.authenticated" (click)="signOutOutlook()"
                                        style="cursor: pointer;" class="bgcolor_01"
                                        title="Logout from Microsoft Account">
                                        Logout
                                    </button>
                                    <button class="btndblue" title="Click to view all outlook" (click)="viewemail()">

                                        View all
                                    </button>
                                </div>
                            </div>
                            <div style="height: 20rem;">
                                <div class="main-list " *ngIf="msAuthService.authenticated">
                                    <div class="outlookmodal-main">
                                        <div class="outlookmodalcontent">
                                            <div *ngFor="let mainmail of groupmail">
                                                <ng-container>
                                                    <ul *ngFor="let submail of mainmail.mails">
                                                        <li>
                                                            <div class="mail-item"
                                                                (click)="loadMessage('' + submail.id + '')">
                                                                <div class="mail-from" style="font-weight: 700;">
                                                                    {{submail.From}}</div>
                                                                <div class="mailSubRow">
                                                                    <div class="mail-sub mail-item-bottom ellipsis quarter-ellipsis3"
                                                                        title="{{submail.Subject}}">
                                                                        {{submail.Subject}}
                                                                    </div>
                                                                    <div class="mail-lst-dt">
                                                                        {{convertTimeToLocal(submail.Recevied)}}</div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="dd-main-todo clmnbox">
                            <app-dashboard-todo-list-alt [data]="'DEFAULT'"></app-dashboard-todo-list-alt>
                        </div>
                    </div>
                </div>
                <div class="dd-main-scheduled">
                    <div class="title">
                        <div>
                            <h4 class="titleBold">
                                Scheduled meeting
                            </h4>
                        </div>
                        <div>
                            <div style="display: inline-flex; column-gap: .5rem; margin-left: auto;">
                                <button *ngIf="!msAuthService?.user" (click)="signInOutlook()" style="cursor: pointer;"
                                    class="bgcolor_01" title="Sign In Microsoft Account">
                                    LogIn
                                </button>
                                <button *ngIf="msAuthService?.user" (click)="signOutOutlook()" class="bgcolor_01"
                                    style="cursor: pointer;" title="Logout from Microsoft Account">
                                    Logout
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="scheduled-content">
                        <div *ngFor="let event of groupDataMeeting">
                            <h4> {{event?.day}}</h4>
                            <ul>
                                <li [ngClass]="event1.color" *ngFor="let event1 of event.meetings">
                                    <span><strong title="{{event1?.organizer}}" class="meeting-ellipsis">{{
                                            event1?.organizer }}</strong>
                                        <small title="{{event1?.subject}}" class="meeting-ellipsis1">
                                            {{event1?.subject}}</small>
                                        <a title="Go To Meeting"> <svg class="meeting-icon">
                                                <use xlink:href="./assets/img/sprite.svg#msteams"
                                                    (click)="redirecttoTeams(event1?.onlineMeetingUrl)">
                                                </use>
                                            </svg></a></span>
                                    {{event1?.startTime}} - {{event1?.endTime}}


                                </li>
                            </ul>
                        </div>

                        <!-- <ul>
                            <li [ngClass]="event.color" *ngFor="let event of calenderEvents">
                                <span><strong>{{ event?.organizer }}</strong> {{event?.subject}}</span>
                                {{ event?.date }} : {{event?.startTime}} - {{event?.endTime}} 
                            </li>
                           
                        </ul> -->
                    </div>
                    <!-- <div class="colmcontent">
                        <div class="newtabcontents" *ngIf="msAuthService.authenticated">
                            <ul class="newmeetinglist contact-outlook-meeting-list"
                                *ngIf="calenderEvents?.length > 0">
                                <li *ngFor="let event of calenderEvents" class="contact-outlook-meeting">
                                    <span>
                                        <strong>Schedule By: {{ event?.organizer }}</strong>
                                        <p class="outlook-contact-details-meeting-text" [title]="event?.title">
                                            {{ event?.title }}
                                        </p>
                                    </span>
                                    <a *ngIf="event?.onlineMeetingUrl" class="outlook-contact-meeting-link"
                                        href="{{event?.onlineMeetingUrl}}" target="_blank">
                                        <button class="btndarkcon" title="Click to open link">
                                            Click here
                                        </button>
                                    </a>
                                    <a *ngIf="!event?.onlineMeetingUrl" class="outlook-contact-meeting-link">
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div> -->
                </div>
            </div>
            <footer *ngIf="isNotLoading" class="newdb-footer ">
                <p [innerHtml]="labelMessages.copyright.copyright_message"></p>
            </footer>
        </div>
        <div class="dd-content-wraper" *ngSwitchCase="'T21'">
            <!-- <div class="ddmaintitlehero">
                <div class="dd-title-main">
                    <h1>Contact Dashboard</h1>
                    <h2>Kindly check the attached updated logos with the changes mentioned below</h2>
                
                </div>
                <div class="add-contact-btn">
                    <button>
                    + Add Contact
                    </button>
                </div>
            </div> -->
            <div class="dd-cards-main">
                <div class="dd-card">
                    <div class="dd-card-text">
                        <h2>Contact</h2>
                        <h1>{{ contactCount }}</h1>
                        <h3>All saved contact entries</h3>
                    </div>
                    <div class="dd-card-arrow">
                        <a class="arrow-link" (click)="Redircttocontactpage()">
                            <svg>
                                <use xlink:href="./assets/img/sprite.svg#sidewards_direction_arrow"></use>
                            </svg>
                        </a>
                    </div>
                </div>
                <div class="dd-card">
                    <div class="dd-card-text">
                        <h2>Customer & Vendor</h2>
                        <h1>{{ custVendorCount }}</h1>
                        <h3>Total registered customers and vendors</h3>
                    </div>
                    <div class="dd-card-arrow arrow-link">
                        <a class="arrow-link"  (click)="RedircttocontactpageWithFilter('Cust & Vendor')">
                            <svg>
                                <use xlink:href="./assets/img/sprite.svg#sidewards_direction_arrow"></use>
                            </svg></a>
                    </div>
                </div>
                <div class="dd-card">
                    <div class="dd-card-text">
                        <h2>Customer</h2>
                        <h1>{{ customerCount }}</h1>
                        <h3>View and manage customer contact details</h3>
                    </div>
                    <div class="dd-card-arrow arrow-link">
                        <a class="arrow-link"  (click)="RedircttocontactpageWithFilter('Customer')">
                            <svg>
                                <use xlink:href="./assets/img/sprite.svg#sidewards_direction_arrow"></use>
                            </svg></a>
                    </div>
                </div>
                <div class="dd-card">
                    <div class="dd-card-text">
                        <h2>Vendor</h2>
                        <h1>{{ vendorCount }}</h1>
                        <h3>View and manage vendor contact details</h3>
                    </div>
                     <div class="dd-card-arrow arrow-link">
                        <a class="arrow-link" (click)="RedircttocontactpageWithFilter('Vendor')">
                        <svg>
                            <use xlink:href="./assets/img/sprite.svg#sidewards_direction_arrow"></use>
                        </svg></a>
                    </div>
                </div>
            </div>
            <div class="dd-main">
                <div class="dd-main-inner">
                    <div class="dd-main-session main-contacts">
                        <div class="activity">
                            <div class="title">
                                <h4 class="titleBold">
                                    Recent contacts
                                </h4>
                                <button class="btndblue" title="Click to view all contacts"
                                    (click)="Redircttocontactpage()">
                                    View all
                                </button>
                            </div>
                            <div class="todoclmn3">
                                <article class="todoclmn3-data">
                                    <ul class="todoclmn3-thead"
                                        style="grid-template-columns: repeat(3, 1fr) 9rem !important;">
                                        <li>
                                            Name
                                        </li>
                                        <li>
                                            Title
                                        </li>
                                        <li>
                                            Company Name
                                        </li>
                                        <li style="justify-content: center !important;">
                                            Quick links
                                        </li>
                                    </ul>
                                    <div style="max-height: 14.5rem;overflow-y: auto;">
                                        <ul *ngFor="let item of contactlist"
                                            style="grid-template-columns: repeat(3, 1fr) 9rem !important;">
                                            <li style="display: flex;justify-content: flex-start;">
                                                <svg class="contact_avatar">
                                                    <use xlink:href="./assets/img/sprite.svg#user_profile_contact">
                                                    </use>
                                                </svg>
                                                <p class="quarter-ellipsis2">
                                                    {{item.gstibo_full_name}}
                                                </p>
                                            </li>
                                            <li>
                                                <span class="quarter-ellipsis2" style="max-width: 12rem !important;">
                                                    {{ item.gstibo_job_title }}
                                                </span>
                                            </li>
                                            <li>
                                                <span class="quarter-ellipsis2">
                                                    {{ item.gstibo_company }}
                                                </span>
                                            </li>
                                            <li style="justify-content: center !important;">
                                                <a href="tel:{{item.gstibo_phone_home}}" target="_blank"
                                                    class="contact-dashboard-anchor">
                                                    <svg title="Click to call">
                                                        <use xlink:href="./assets/img/sprite.svg#phone_contact_new">
                                                        </use>
                                                    </svg>
                                                </a>
                                                <a href="mailto:{{item.gstibo_email_address}}" target="_blank"
                                                    class="contact-dashboard-anchor">
                                                    <svg title="Click to mail">
                                                        <use xlink:href="./assets/img/sprite.svg#email_contact"></use>
                                                    </svg>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </article>
                            </div>
                        </div>
                        <div class="activity">
                            <app-dashboard-contact-status></app-dashboard-contact-status>
                        </div>
                    </div>
                    <div class="dd-main-outlook-todo-con-default ">
                        <div class="dd-main-outlook clmnbox" style="height: 21rem;">
                            <div class="title">
                                <h4 class="titleBold">
                                    Outlook
                                </h4>
                                <div style="display: inline-flex; column-gap: .5rem; margin-left: auto;">
                                    <button *ngIf="!msAuthService.authenticated" (click)="signInOutlook()"
                                        style="cursor: pointer;" class="bgcolor_01" title="Sign In Microsoft Account">
                                        LogIn
                                    </button>
                                    <button *ngIf="msAuthService.authenticated" (click)="signOutOutlook()"
                                        style="cursor: pointer;" class="bgcolor_01"
                                        title="Logout from Microsoft Account">
                                        Logout
                                    </button>
                                    <button class="btndblue" title="Click to view all outlook" (click)="viewemail()">

                                        View all
                                    </button>
                                </div>
                            </div>
                            <div>
                                <div class="main-list " *ngIf="msAuthService.authenticated">
                                    <div class="outlookmodal-main">
                                        <div class="outlookmodalcontent">
                                            <div *ngFor="let mainmail of groupmail">
                                                <ng-container>
                                                    <ul *ngFor="let submail of mainmail.mails">
                                                        <li>
                                                            <div class="mail-item"
                                                                (click)="loadMessage('' + submail.id + '')">
                                                                <div class="mail-from" style="font-weight: 700;">
                                                                    {{submail.From}}</div>
                                                                <div class="mailSubRow">
                                                                    <div class="mail-sub mail-item-bottom ellipsis quarter-ellipsis3"
                                                                        title="{{submail.Subject}}">
                                                                        {{submail.Subject}}
                                                                    </div>
                                                                    <div class="mail-lst-dt">
                                                                        {{convertTimeToLocal(submail.Recevied)}}</div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="dd-main-todo clmnbox" style="height: 21rem;">
                            <app-dashboard-todo-list-alt [data]="'DEFAULT'"></app-dashboard-todo-list-alt>
                        </div>
                    </div>
                </div>
                <div class="dd-main-scheduled">
                    <div class="title">
                        <div>
                            <h4 class="titleBold">
                                Scheduled meeting
                            </h4>
                        </div>
                        <div>
                            <div style="display: inline-flex; column-gap: .5rem; margin-left: auto;">
                                <button *ngIf="!msAuthService.authenticated" (click)="signInOutlook()"
                                    style="cursor: pointer;" class="bgcolor_01" title="Sign In Microsoft Account">
                                    LogIn
                                </button>
                                <button *ngIf="msAuthService.authenticated" (click)="signOutOutlook()"
                                    class="bgcolor_01" style="cursor: pointer;" title="Logout from Microsoft Account">
                                    Logout
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="scheduled-content" *ngIf="msAuthService.authenticated">
                        <div *ngFor="let event of groupDataMeeting">
                            <h4> {{event?.day}}</h4>
                            <ul>
                                <li [ngClass]="event1.color" *ngFor="let event1 of event.meetings">
                                    <span>
                                        <strong title="{{event1?.organizer}}" class="meeting-ellipsis">
                                            {{ event1?.organizer }}</strong>
                                        <small title="{{event1?.subject}}" class="meeting-ellipsis1">
                                            {{event1?.subject}}</small>
                                        <a title="Go To Meeting"> <svg class="meeting-icon">
                                                <use xlink:href="./assets/img/sprite.svg#msteams"
                                                    (click)="redirecttoTeams(event1?.onlineMeetingUrl)">
                                                </use>
                                            </svg></a></span>
                                    {{event1?.startTime}} - {{event1?.endTime}}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <footer *ngIf="isNotLoading" class="newdb-footer ">
                <p [innerHtml]="labelMessages.copyright.copyright_message"></p>
            </footer>
        </div>
        <div class="dd-content-wraper" *ngSwitchCase="'T22'">
            <<<<<<< .mine ||||||| .r8942 <div class="dd-title-main">
                <h1>Procurement Dashboard</h1>
                <h2>
                    This Procurement Dashboard provides a real-time overview of opportunities, revenue and proposal
                    status,
                    helping teams track performance, manage pipelines and make informed decisions efficiently.
                </h2>
        </div>
        =======
        <div class="dd-title-main">
            <h1>Procurement Dashboard</h1>
            <h2>
                This Procurement Dashboard provides a real-time overview of opportunities, revenue and proposal
                status,
                helping teams track performance, manage pipelines and make informed decisions efficiently.
            </h2>
        </div>
        >>>>>>> .r8959
        <div class="dd-cards-main">
            <div class="dd-card">
                <div class="dd-card-text">
                    <h2>Active Opportunities</h2>
                    <h1>30</h1>
                    <h3>Total number of approved opportunities.</h3>
                </div>
                <div class="quarter-dropdown">
                    <select class="quarter-select">
                        <option>Q1</option>
                        <option>Q2</option>
                        <option>Q3</option>
                        <option>Q4</option>
                    </select>
                </div>
            </div>
            <div class="dd-card">
                <div class="dd-card-text">
                    <h2>Total Number of Proposal</h2>
                    <h1>10</h1>
                    <h3>Total number of proposals.</h3>
                </div>
                <div class="quarter-dropdown">
                    <select class="quarter-select">
                        <option>Q1</option>
                        <option>Q2</option>
                        <option>Q3</option>
                        <option>Q4</option>
                    </select>
                </div>
            </div>
            <div class="dd-card">
                <div class="dd-card-text">
                    <h2>Awards In Progress</h2>
                    <h1>6</h1>
                    <h3>Opportunities awaiting approval.</h3>
                </div>
                <div class="quarter-dropdown">
                    <select class="quarter-select">
                        <option>Q1</option>
                        <option>Q2</option>
                        <option>Q3</option>
                        <option>Q4</option>
                    </select>
                </div>
            </div>
            <div class="dd-card">
                <div class="dd-card-text">
                    <h2>Total Revenue</h2>
                    <h1>$ {{ totalRevenue }}</h1>
                    <h3>Revenue closed for the selected Quarter.</h3>
                </div>
                <div class="quarter-dropdown">
                    <select class="quarter-select" [(ngModel)]="selectedRevenueQuarter" (change)="updateRevenue()">
                        <option value="Q1">Q1</option>
                        <option value="Q2">Q2</option>
                        <option value="Q3">Q3</option>
                        <option value="Q4">Q4</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="dd-main-procurement">
            <div class="dd-main-inner">
                <div class="dd-main-session-procurement">
                    <div class="summary">
                        <div class="stage-opportunity">
                            <h3 style="font-weight: 600;">Opportunity By Stage</h3>
                            <div class="stage-opportunity-inner"
                                style="display: grid; grid-template-columns: repeat(2, 1fr); column-gap: 1rem;">
                                <div>
                                    <p>
                                        Opportunity
                                        <span>
                                            {{ stageSummaryMap['Opportunity'] }}
                                        </span>
                                    </p>
                                    <p>
                                        Feasibility
                                        <span>
                                            {{ stageSummaryMap['Feasibility'] }}
                                        </span>
                                    </p>
                                    <p>
                                        Capture Mgmt.
                                        <span>
                                            {{ stageSummaryMap['Capture Mgmt.'] }}
                                        </span>
                                    </p>
                                </div>
                                <div>
                                    <p>
                                        Proposal
                                        <span>
                                            {{ stageSummaryMap['Proposal'] }}
                                        </span>
                                    </p>
                                    <p>
                                        Submission
                                        <span>
                                            {{ stageSummaryMap['Submission'] }}
                                        </span>
                                    </p>
                                    <p>
                                        Award Mgmt.
                                        <span>
                                            {{ stageSummaryMap['Award Mgmt.'] }}
                                        </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="proposal-status">
                            <h3 style="font-weight: 600;">Proposal By Status</h3>
                            <div class="proposal-status-inner">
                                <p>
                                    Submitted
                                    <span>
                                        {{ stageSummaryMap['Submission'] }}
                                    </span>
                                </p>
                                <p>
                                    Approved
                                    <span>
                                        {{ totalProposalApprovedCount }}
                                    </span>
                                </p>
                                <p>
                                    Awarded
                                    <span>
                                        {{ stageSummaryMap['Award Mgmt.'] }}
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="activity">
                        <div class="title">
                            <h4 class="titleBold">
                                Monthly Trend
                            </h4>
                            <select>
                                <option>2025</option>
                                <option>2024</option>
                            </select>
                        </div>
                        <div>
                            <div style="width: 100%;">
                                <app-chart-controls [chartForm]="chartFormLineTrend"></app-chart-controls>
                            </div>
                        </div>
                    </div>
                    <div class="clmnbox" style="border-radius: 8px;overflow: hidden;height: auto;">
                        <div class="title">
                            <h4 class="titleBold">
                                Top 10 Opportunity Status
                            </h4>
                        </div>
                        <div class="stage-table-wrapper">
                            <table class="stage-table">
                                <thead>
                                    <tr>
                                        <th style="width: 10rem;">OP-ID</th>
                                        <th style="width: 12rem;">Agency</th>
                                        <th>Stage</th>
                                    </tr>
                                </thead>
                            </table>
                            <div style="max-height: 17rem;overflow-y: auto;">
                                <table class="stage-table">
                                    <tbody>
                                        <tr *ngFor="let row of top10Opportunity"
                                            [ngClass]="getRowClass(row.gstibo_status)">
                                            <td style="width: 10rem;">
                                                <span
                                                    style="width: 8rem;text-overflow: ellipsis;overflow: hidden;display: block;white-space: nowrap;">{{
                                                    row.gstibo_opportunity_Id }}</span>
                                            </td>
                                            <td class="agency" style="width: 12rem;">{{ row.gstibo_agency }}</td>
                                            <td>
                                                <span class="stage-pill" [ngClass]="getPillClass(row.gstibo_status)">
                                                    {{ row.gstibo_status }}
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="dd-main-outlook-todo">
                    <div class="dd-main-outlook-todo-sub">
                        <div class="dd-main-outlook clmnbox">
                            <div class="title">
                                <h4 class="titleBold">
                                    Outlook
                                </h4>
                                <div style="display: inline-flex; column-gap: .5rem; margin-left: auto;">
                                    <button *ngIf="!msAuthService.authenticated" (click)="signInOutlook()"
                                        style="cursor: pointer;" class="bgcolor_01" title="Sign In Microsoft Account">
                                        LogIn
                                    </button>
                                    <button *ngIf="msAuthService.authenticated" (click)="signOutOutlook()"
                                        style="cursor: pointer;" class="bgcolor_01"
                                        title="Logout from Microsoft Account">
                                        Logout
                                    </button>
                                    <button class="btndblue" title="Click to view all outlook" (click)="viewemail()">

                                        View all
                                    </button>
                                </div>
                            </div>
                            <div style="height: 20rem;">
                                <div class="main-list " *ngIf="msAuthService.authenticated">
                                    <div class="outlookmodal-main">
                                        <div class="outlookmodalcontent">
                                            <div *ngFor="let mainmail of groupmail">
                                                <ng-container>
                                                    <ul *ngFor="let submail of mainmail.mails">
                                                        <li>
                                                            <div class="mail-item"
                                                                (click)="loadMessage('' + submail.id + '')">
                                                                <div class="mail-from" style="font-weight: 700;">
                                                                    {{submail.From}}</div>
                                                                <div class="mailSubRow">
                                                                    <div class="mail-sub mail-item-bottom ellipsis quarter-ellipsis3"
                                                                        title="{{submail.Subject}}">
                                                                        {{submail.Subject}}
                                                                    </div>
                                                                    <div class="mail-lst-dt">
                                                                        {{convertTimeToLocal(submail.Recevied)}}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="clmnbox">
                            <div class="title">
                                <h4 class="titleBold">
                                    Opportunities By Type
                                </h4>
                            </div>
                            <div>
                                <div style="width: 100%;">
                                    <app-chart-controls [chartForm]="chartFormDonut"></app-chart-controls>
                                </div>
                            </div>
                        </div>
                        <div class="clmnbox" style="max-width: 20rem;">
                            <div class="title">
                                <h4 class="titleBold">
                                    Top 5 Proposal Owners
                                </h4>
                            </div>
                            <div style="height: 20rem;">
                                <ul class="owner-list">
                                    <li>
                                        <span class="rank blue">1</span>
                                        <span class="name">Robert William</span>
                                    </li>
                                    <li>
                                        <span class="rank green">2</span>
                                        <span class="name">Jack Sparrow</span>
                                    </li>
                                    <li>
                                        <span class="rank pink">3</span>
                                        <span class="name">John Wick</span>
                                    </li>
                                    <li>
                                        <span class="rank orange">4</span>
                                        <span class="name">Jaison Stathom</span>
                                    </li>
                                    <li>
                                        <span class="rank purple">5</span>
                                        <span class="name">Michael Jordan</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="dd-main-todo clmnbox">
                        <app-dashboard-todo-list-alt [data]="'DEFAULT'"></app-dashboard-todo-list-alt>
                    </div>
                </div>
            </div>
        </div>
        <footer *ngIf="isNotLoading" class="newdb-footer ">
            <p [innerHtml]="labelMessages.copyright.copyright_message"></p>
        </footer>
        </div>
        <div class="dd-content-wraper" *ngSwitchCase="'T23'">
            <!-- <div class="dd-title-main">
                <h1>Recrutiment Dashboard</h1>
                <h2>A centralized view to track hiring progress, candidate pipeline,and recruitment performance in real time.  </h2>
            </div> -->
            <div class="dd-cards-main">
                <div class="dd-card">
                    <div class="dd-card-text">
                        <h2>Open Requisition</h2>
                        <h1>20</h1>
                        <h3>Total Req. created & submitted this month</h3>
                    </div>
                    <div class="dd-card-arrow">
                        <svg>
                            <use xlink:href="./assets/img/sprite.svg#sidewards_direction_arrow"></use>
                        </svg>
                    </div>
                </div>
                <div class="dd-card">
                    <div class="dd-card-text">
                        <h2>Candidates in Pipeline</h2>
                        <h1>45</h1>
                        <h3>Total candidates currently being reviewed </h3>
                    </div>
                    <div class="dd-card-arrow">
                        <svg>
                            <use xlink:href="./assets/img/sprite.svg#sidewards_direction_arrow"></use>
                        </svg>
                    </div>
                </div>
                <div class="dd-card">
                    <div class="dd-card-text">
                        <h2>Offers Extended this Month</h2>
                        <h1>10</h1>
                        <h3>Total Offers Extended</h3>
                    </div>
                    <div class="dd-card-arrow">
                        <svg>
                            <use xlink:href="./assets/img/sprite.svg#sidewards_direction_arrow"></use>
                        </svg>
                    </div>
                </div>
                <div class="dd-card">
                    <div class="dd-card-text">
                        <h2>Average Time to Hire</h2>
                        <h1>10 Days</h1>
                        <h3>Average time from application to offer</h3>
                    </div>
                    <div class="dd-card-arrow">
                        <svg>
                            <use xlink:href="./assets/img/sprite.svg#sidewards_direction_arrow"></use>
                        </svg>
                    </div>
                </div>
            </div>
            <div class="dd-main">
                <div class="dd-main-inner">
                    <div class="dd-main-session">
                        <div class="summary">
                            <div class="account-summary" style="padding: .5rem;">
                                <h3 style="font-weight: 600;">Recruitment Summary</h3>
                                <div class="dd-main-summary-inner">
                                    <p>
                                        Active Requsitions Date
                                        <span class="dd-main-summary-card-span">
                                            {{accountCreatedDate }}
                                        </span>
                                    </p>
                                    <p>
                                        Positions Filled (MTD)
                                        <span class="dd-main-summary-card-span">
                                            {{lastLoginDate }}
                                        </span>
                                    </p>
                                    <p>
                                        Pending Approvals
                                        <span class="dd-main-summary-card-span">
                                            {{lastLoginDate }}
                                        </span>
                                    </p>

                                </div>
                            </div>
                            <div class="dd-resource">
                                <div>
                                    <h3 style="font-weight: 600;">Resource Type-New Hires</h3>

                                </div>
                                <div class="dd-main-summary-inner"
                                    style="display: grid; grid-template-columns: repeat(2, 1fr); column-gap: 1rem;">
                                    <p *ngFor="let r of resources">
                                        {{ r.name }}
                                        <span class="dd-main-summary-card-spanrec">
                                            {{ r.count }}
                                        </span>
                                    </p>
                                </div>

                            </div>
                        </div>
                        <div class="activity">
                            <div class="title">
                                <h4 class="titleBold">
                                    Recent Recruitment Activity
                                </h4>
                            </div>
                            <div class="todoclmn3">
                                <article class="todoclmn3-data">
                                    <ul class="todoclmn3-thead" style="padding: 0;">
                                        <li>
                                            Details
                                        </li>
                                        <li style="justify-content: left !important;">
                                            Activity Type
                                        </li>
                                        <li>
                                            Action
                                        </li>
                                        <li>
                                            Updated Date
                                        </li>
                                    </ul>
                                    <div style="max-height: 14.5rem;overflow-y: auto;">
                                        <ul *ngFor="let tr of activityDataRecruitment">
                                            <li class="quarter-ellipsis-act" title="{{tr.auditlog}}">
                                                {{tr.auditlog}}
                                            </li>
                                            <li class="quarter-ellipsis-act">
                                                {{tr.gstibo_page_name}}
                                            </li>
                                            <li style="color: black;">
                                                {{tr.gstibo_action}}
                                            </li>
                                            <li style="color: black;">
                                                {{tr.gstibo_created_on | date : custDateFormat_date }}
                                            </li>
                                        </ul>
                                    </div>
                                </article>
                            </div>
                        </div>
                    </div>
                    <div class="dd-main-outlook-chart">
                        <div class="dd-main-outlook clmnbox activity">
                            <div class="title">
                                <h4 class="titleBold">
                                    Outlook
                                </h4>
                                <div style="display: inline-flex; column-gap: .5rem; margin-left: auto;">
                                    <button *ngIf="!msAuthService.authenticated" (click)="signInOutlook()"
                                        style="cursor: pointer;" class="bgcolor_01" title="Sign In Microsoft Account">
                                        LogIn
                                    </button>
                                    <button *ngIf="msAuthService.authenticated" (click)="signOutOutlook()"
                                        style="cursor: pointer;" class="bgcolor_01"
                                        title="Logout from Microsoft Account">
                                        Logout
                                    </button>
                                    <button class="btndblue" title="Click to view all outlook" (click)="viewemail()">

                                        View all
                                    </button>
                                </div>
                            </div>
                            <div style="height: 20rem;">
                                <div class="main-list " *ngIf="msAuthService.authenticated">
                                    <div class="outlookmodal-main">
                                        <div class="outlookmodalcontent">
                                            <div *ngFor="let mainmail of groupmail">
                                                <ng-container>
                                                    <ul *ngFor="let submail of mainmail.mails">
                                                        <li>
                                                            <div class="mail-item"
                                                                (click)="loadMessage('' + submail.id + '')">
                                                                <div class="mail-from" style="font-weight: 700;">
                                                                    {{submail.From}}</div>
                                                                <div class="mailSubRow">
                                                                    <div class="mail-sub mail-item-bottom "
                                                                        title="{{submail.Subject}}">
                                                                        <span
                                                                            class="recruitmentsub">{{submail.Subject}}</span>
                                                                    </div>
                                                                    <div class="mail-lst-dt">
                                                                        {{convertTimeToLocal(submail.Recevied)}}</div>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="dd-main-todo clmnbox activity">
                            <div class="title">
                                <h4 class="titleBold">
                                    Hiring Pipeline Status
                                </h4>
                            </div>
                            <div>
                                <app-chart-controls [chartForm]="chartFormRecpipline"></app-chart-controls>
                            </div>
                        </div>
                        <div class="dd-main-todo clmnbox activity">
                            <div class="title">
                                <h4 class="titleBold">
                                    Offer Acceptance Rate
                                </h4>
                            </div>
                            <div>
                                <app-chart-controls [chartForm]="chartFormRecOffer"></app-chart-controls>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="dd-main-scheduled">
                    <div class="title">
                        <div>
                            <h4 class="titleBold">
                                Scheduled meeting
                            </h4>
                        </div>
                        <div>
                            <div style="display: inline-flex; column-gap: .5rem; margin-left: auto;">
                                <button *ngIf="!msAuthService?.user" (click)="signInOutlook()" style="cursor: pointer;"
                                    class="bgcolor_01" title="Sign In Microsoft Account">
                                    LogIn
                                </button>
                                <button *ngIf="msAuthService?.user" (click)="signOutOutlook()" class="bgcolor_01"
                                    style="cursor: pointer;" title="Logout from Microsoft Account">
                                    Logout
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="scheduled-content">
                        <div *ngFor="let event of groupDataMeeting">
                            <h4> {{event?.day}}</h4>
                            <ul>
                                <li [ngClass]="event1.color" *ngFor="let event1 of event.meetings">
                                    <span><strong title="{{event1?.organizer}}" class="meeting-ellipsis">{{
                                            event1?.organizer }}</strong>
                                        <small title="{{event1?.subject}}" class="meeting-ellipsis1">
                                            {{event1?.subject}}</small>
                                        <a title="Go To Meeting"> <svg class="meeting-icon">
                                                <use xlink:href="./assets/img/sprite.svg#msteams"
                                                    (click)="redirecttoTeams(event1?.onlineMeetingUrl)">
                                                </use>
                                            </svg></a></span>
                                    {{event1?.startTime}} - {{event1?.endTime}}


                                </li>
                            </ul>
                        </div>


                    </div>

                </div>
            </div>
            <footer *ngIf="isNotLoading" class="newdb-footer ">
                <p [innerHtml]="labelMessages.copyright.copyright_message"></p>
            </footer>
        </div>


    </ng-container>
</ng-template>